// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div#ActivateAcc {
  width: 725px;
  box-shadow: -5px 0px 14px #0000000D;
  border-radius: 34px 0px 0px 34px;
  border-left: 5px solid #00A19B;
  padding: 30px 0px 0px 40px;
  z-index: 99999;
  border: none;
}

div#customizeDatecanvasRight {
  width: 725px;
  box-shadow: -5px 0px 14px #0000000D;
  border-radius: 34px 0px 0px 34px;
  border-left: 5px solid #00A19B;
  padding: 30px 0px 0px 40px;
  z-index: 99999;
  border: none;
}

div#customizeDatecanvasRight .offcanvas-body {
  padding: 0px 60px;
}

.offcanvas-header {
  display: flex;
  align-items: center;
  text-align: left;
  justify-content: space-between;
  padding: 1rem 1rem;
  border-bottom: 1px solid #ccc;
  margin: 0px 60px;
}

.notification-drawer-main-wrapper {
  overflow: auto;
  height: 94vh;
}

.profile-icon {
  display: flex;
  align-items: center;
}

.offcanvas-body {
  overflow: auto;
  /* height: 100vh; */
  padding-bottom: 100px;
}

.profile-icon img {
  width: 40px;
  height: 40px;
  cursor: pointer;
  object-fit: cover;
  object-position: center;
}

.profile-icon {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 20px;
  margin-left: 30px;
}

.profile-icon p {
  color: #383838;
  font-size: 16px;
  margin: 0px;
  cursor: pointer;
}

.profile-drawer-bottom {
  /* margin-top: 75%; */
  border-top: 1px solid #ccc;
  padding: 15px;
}

.profile-drawer-bottom button {
  background: var(--buttonColor);
  border-radius: 5px;
  opacity: 1;
  border: none;
  color: #383838;
  padding: 10px;
  width: 70%;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
}

.profile-drawer-bottom button:hover {
  background-color: var(--buttonHover);
}

.principle-open-drawer .table > tbody {
  vertical-align: inherit;
  border-top: 2px solid #ccc !important;
  border-left: none;
  border-right: none;
}

.principle-open-drawer .table > tbody td {
  color: #717171;
  text-align: center;
  font-size: 15px;
}

.principle-open-drawer .table > tbody th {
  color: #383838;
  text-align: center;
}

.principle-open-drawer .table > :not(caption) > * > * {
  padding: 12px;
  font-size: 14px;
}

.principle-open-drawer .table-header {
  display: flex;
  align-items: center;
  justify-content: space-around;
  gap: 31px;
  background: #fff4d5;
  padding: 6px 0px;
  text-align: center;
  border-bottom: 1.5px solid #5e5e5e;
  margin-top: -16px;
}

.principle-open-drawer .table-header p {
  margin: 0px;
  color: #383838;
  font-size: 13px;
  font-weight: 500;
}

.tranfer-manage-holder img {
  width: 15px;
  cursor: pointer;
}

/* .close-principle-drawer-footer {
  position: absolute;
  bottom: 80px;
} */

.profit-total-wrap {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 150px;
  border-bottom: 1.5px solid #383838;
}

.profit-total-wrap h3 {
  font-size: 16px;
  color: #383838;
  margin: 0px;
  padding-bottom: 8px;
}

.profit-total-wrap p {
  font-size: 14px;
  color: #383838;
  margin: 0px;
  padding-bottom: 8px;
}

.total-profit-wrapper {
  display: flex;
  justify-content: space-between;
  margin-top: 15px;
}

.total-profit h2 {
  font-size: 18px;
  color: #383838;
}

.total-profit-balance button {
  border: 1.5px solid transparent;
  background: var(--buttonBorder);
  background-origin: border-box;
  border-radius: 6px;
  box-shadow: inset 2px 1000px 1px #fff;
}

/********** Create Principle *****/
.currency-box {
  width: 90px;
  height: 40px;
  border: 1px solid var(--buttonColor);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

.currency-box img {
  width: 30px;
  height: 30px;
}

.currency-box p {
  font-size: 16px;
  margin: 0px;
  color: #383838 !important;
}

.principle-currency-wrap {
  display: flex;
  align-items: center;
  justify-content: space-around;
}

.principle-currency-wrap p {
  font-size: 14px;
  color: #858585;
  margin: 0px;
}

.subscription-amount-wrap {
  width: 80%;
  margin: 0 auto;
  margin-top: 20px;
}

.subscription-amount-wrap input {
  width: 100%;
  padding: 5px 15px;
  border: 1px solid #707070;
  border-radius: 6px;
  font-size: 17px;
  color: #858585;
  font-weight: 200;
  outline: none;
}

.subscription-amount-wrap p {
  padding-top: 9px;
  font-size: 12px;
  color: #858585;
}

.principle-summary-wrapper {
  width: 80%;
  margin: 0 auto;
}

/* .summary-wrap {
  display: flex;
  justify-content: center;
  align-items: center;
} */

.time-box {
  width: 24px;
  height: 25px;
  border-radius: 5px;
  background: var(--buttonColor);
}

.date-box {
  width: 24px;
  height: 25px;
  border-radius: 5px;
  background: #275354;
}

.create-time {
  display: flex;
  justify-content: space-between;
  padding-top: 10px;
}

.summary-right p {
  font-size: 14px;
}

.vartcal-line {
  height: 31px;
  width: 2px;
  background: #707070;
  text-align: center;
  margin-left: 10px;
}

.time-box-wrap {
  display: flex;
  gap: 10px;
}

.time-box-wrap p {
  font-size: 15px;
  color: #383838;
}

.summary-time p {
  font-size: 12px;
  color: #858585;
}

.principle-security {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  width: 100%;
  text-align: center;
}

.principle-security img {
  width: 30px;
  height: 30px;
}

.principle-security p {
  font-size: 10px;
  margin: 0px;
  color: #9c9c9c;
}

.procced-button button {
  background: var(--buttonColor);
  border-radius: 5px;
  opacity: 1;
  border: none;
  color: #383838;
  padding: 8px 50px;
  margin-top: 20px;
}

.procced-button button:hover {
  background-color: var(--buttonHover);
}

.procced-button {
  text-align: center;
  border-bottom: 1px solid #707070;
  padding-bottom: 24px;
}

.confirm-button-wrap button {
  background: #00A19B;
  border-radius: 10px;
  opacity: 1;
  border: none;
  color: #fff;
  padding: 8px 40px;
  margin-top: 20px;
}


svg.drawer-cross-icon{
  cursor: pointer;
  width: 38px;
  height: 38px;
}

svg.drawer-cross-icon:hover path{
  fill: #00A19B; 
}

.confirm-button-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

button.cancel-button {
  background: #F3F3F3;
  border: 1px solid #00A19BF7 !important;
  border-radius: 10px;
  opacity: 1;
  border: none;
  color: #00A19BF7;
  padding: 8px 40px;
  margin-top: 20px;
}

/********* Wallet Drawer *******/

.wallet-drawer-wrapper {
  width: 80%;
  margin: 0 auto;
}

.overview-right img {
  width: 20px;
  height: 20px;
}

.wallet-overview {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px dashed #ccc;
  padding-bottom: 8px;
}

.overview-right h3 {
  font-size: 15px;
  color: #858585;
}

.overview-right p {
  font-size: 24px;
  margin: 0px;
  display: flex;
  align-items: center;
  gap: 5px;
}
.overview-right span {
  color: #858585;
  font-size: 15px;
}

.overview-left h4 {
  color: #858585;
  font-size: 17px;
  margin: 0px;
}

.wealth-transfer-wrap {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 25px;
}

.wealth-transfer-right button {
  background: var(--buttonColor);
  border-radius: 5px;
  opacity: 1;
  border: none;
  color: #383838;
  padding: 5px 10px;
}

.wealth-transfer-right h3 {
  color: #383838;
  font-size: 16px;
  cursor: pointer;
}

.wealth-transfer-left h3 {
  color: #383838;
  font-size: 16px;
}

.wealth-transfer-left span {
  font-size: 12px;
  color: #858585;
}

.wealth-transfer-left p {
  font-size: 15px;
  color: #858585;
  margin: 0px;
}

.wealth-transfer-wrapper {
  border-bottom: 1px dashed #ccc;
  padding-bottom: 20px;
}

.wealth-transfer-wrapper-2 {
  border-bottom: 1px solid #ccc;
  padding-bottom: 20px;
}

.tranfer-manage-holder {
  width: 100%;
  height: 245px;
  box-shadow: 0px 3px 6px #00000029;
  border: 1px solid #fbc425;
  border-radius: 9px;
  margin-top: 3px;
  text-align: center;
  background: #fff;
}

.transfer-select-wraper {
  display: flex;
  justify-content: space-between;
  margin: 10px 6px;
  align-items: center;
  margin-top: 5px;
  gap: 10px;
}

.transfer-select-wraper-2 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 10px 6px;
  gap: 10px;
  text-align: left;
}

.transfer-filter {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.transfer-filter select {
  padding: 8px 10px;
  border: 1px solid var(--buttonColor);
  border-radius: 5px;
  outline: none;
  color: #383838;
  font-size: 14px;
  font-weight: 300;
  width: 114px;
}

.transfer-icon {
  background: var(--buttonColor);
  padding: 3px 8px;
  border-radius: 6px;
  box-shadow: 0px 3px 6px #00000029;
}

.transfer-filter input {
  padding: 8px 10px;
  border: 1px solid var(--buttonColor);
  border-radius: 5px;
  outline: none;
  color: #383838;
  font-size: 14px;
  font-weight: 300;
  width: 114px;
}
.transfer-filter.quantity {
  position: relative;
}

.count-button {
  position: absolute;
  right: 8px;
  top: 29px;
  display: flex;
  align-items: center;
  gap: 8px;
  background-color: #fff;
}

.count-button .plus-btn {
  width: 20px;
  height: 14px;
  background: #383838;
  color: #fff;
  margin-bottom: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.count-button p {
  font-size: 12px;
  color: #717171;
  margin: 0px;
}

.transfer-filter h3 {
  font-size: 14px;
  margin: 0px;
  color: #383838;
}

.confirm-buttons button {
  background: var(--buttonColor);
  border-radius: 5px;
  opacity: 1;
  border: none;
  color: #383838;
  padding: 5px 10px;
  margin-top: 20px;
}

.tranfer-manage-holder img {
  width: 15px;
  cursor: pointer;
}

.continue-wrap {
  display: flex;
  align-items: center;
  justify-content: space-around;
}

.box-1 {
  width: 15px;
  height: 15px;
  border-radius: 3px;
  background: var(--buttonColor);
}

.box-2 {
  width: 15px;
  height: 15px;
  border-radius: 3px;
  background: #275354;
}

.continue-wrap p {
  font-size: 13px;
  margin: 0px;
}

.arrow svg {
  font-size: 21px;
}

.box-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
}

.transfer-line {
  width: 50px;
  height: 1.5px;
  background: #383838;
}

.wealth-transfer-right button:hover {
  background-color: var(--buttonHover);
}

.confirm-buttons button:hover {
  background-color: var(--buttonHover);
}


/************ Customize Time Range ********/
.time-range-wrapper {
  display: flex;
  /* align-items: center; */
  justify-content: center;
  flex-direction: column;
  /* margin-top: 70px; */
  height: calc(100vh - 450px);
}

.time-range-wrapper input {
  width: 100%;
  padding: 8px 20px;
  border-radius: 10px;
  font-size: 14px;
  background-color: #F8F8F8;
  height: 85px;
  border: none;
  outline: none;
}

.time-range-wrapper label {
  font-size: 22px;
  text-align: left;
  padding-bottom: 8px;
  color: #383838;
  margin-left: 20px;
  font-family: 'Montserrat';
  font-weight: 400;
}

.customize-time-wrap p {
  font-size: 24px;
  color: #717171;
  font-family: 'Montserrat';
  font-weight: 400;
  margin-top: 30px;
}

.time-range-wrapper h4 {
  font-size: 20px;
  padding: 30px 0px;
  text-align: center;
  margin: 0px;
  color: #00A19B;
}

.customize-security {
  display: flex;
  /* align-items: center; */
  justify-content: center;
  width: 100%;
  margin: 0 auto;
  gap: 15px;
  border-bottom: 1px solid #F8F8F8;
  padding-bottom: 10px;
}

.customize-security img {
  width: 30px;
  height: 30px;
  margin-top: 7px;
}

.customize-range-footer {
  margin-top: 80px;
}

.customize-security p {
  font-size: 16px;
  margin: 0px;
  color: #9c9c9c;
}

.customize-btn {
  text-align: center;
  margin-top: 20px;
}

.customize-btn button {
  background: #00A19B;
  border-radius: 5px;
  opacity: 1;
  border: none;
  padding: 8px 40px;
  width: 100%;
  height: 70px;
  color: #fff;
}

.customize-btn button:hover {
  background-color: #fff;
  border: 2px solid #00A19B;
  color: #383838;
}

.start-time {
  width: 100%;
}


.wealth-transfer-right .wealth-hover {
  font-size: 0px;
}

span.wealth-hover img {
  height: 0px;
}

.wealth-transfer-right h3:hover span.wealth-hover img {
  height: 16px;
}

.wealth-transfer-right h3:hover .wealth-hover {
  font-size: 16px;
  color: #ffd458;
  transition: all 500ms ease-in-out;
}

.wealth-transfer-right h3:hover .wealth {
  font-size: 0px;
  transition: 0.2s;
}

.profile-content-wrap {
  min-height: calc(100vh - 180px);
}

/********** Mobile filter *******/
.mobile-drawer-filter select {
  padding: 12px 15px;
  margin-bottom: 20px;
  border: 1px solid var(--buttonColor);
  border-radius: 5px;
  outline: none;
  font-weight: 400;
  gap: 20px;
  cursor: pointer;
  background: #fff !important;
  font-size: 20px;
  color: #383838;
}

.mobile-filter-drawer-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 40px;
  margin: 0px 20px;
}

.mobile-filter-drawer-wrap h3 {
  font-size: 24px;
  color: #383838;
  padding-top: 30px;
}

/************* Activate Account Drawer *******/
.activate-acc-wrap {
  /* text-align: center; */
  margin: 0px 45px;
}


.security-logo {
  text-align: center;
}


.activate-acc-wrap p {
  font-size: 24px;
  color: #383838;
  margin-top: 50px;
}

.security-logo img {
  width: 200px;
  height: 200px;
  object-fit: contain;
  margin-top: 150px;
}


.twofa-disable-drawer-wrapper {
  margin: 0px 60px;
}


.twofa-status-drawer-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
  height: calc(100vh - 350px);
}

.twofa-status-drawer-wrapper img{
  width: 140px;
  height: auto;
}

.twofa-status-drawer-wrapper p {
  font-size: 22px;
  color: #383838;
  /* margin: 0px; */
  margin-top: 15px !important;
  margin-bottom: 0px;
}


.twofa-status-drawer-wrapper h2 {
  font-size: 32px;
  color: #1AA400;
  font-weight: 500;
}

@media (max-width: 768px) {

  .offcanvas-header {
    margin: 0px 30px;
  }

  .profile-content-wrap {
    min-height: calc(100vh - 240px);
  }

  .principle-currency-wrap {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;
  }

  .currency-box {
    width: 129px;
    height: 63px;
  }

  .currency-box img {
    width: 38px;
    height: 38px;
  }
  .principle-currency-wrap p {
    font-size: 18px;
  }
  .subscription-amount-wrap input {
    width: 100%;
    height: 65px;
    font-size: 20px;
  }

  .subscription-amount-wrap p {
    padding-top: 9px;
    font-size: 14px;
    color: #858585;
    text-align: center;
    margin-top: 12px;
  }
  .time-box-wrap p {
    font-size: 16px;
    color: #383838;
  }
  .procced-button button {
    font-size: 20px;
  }
  .principle-security p {
    font-size: 11px;
  }
  .principle-summary-wrapper h4 {
    font-size: 24px;
  }
  .create-time.total-principle {
    margin: 20px 0px;
  }

  .activate-acc-wrap p {
    font-size: 14px;
    color: #717171;
    text-align: left;
    margin-top: 40px;
  }

  .security-logo img {
    width: 160px;
    height: 160px;
    object-fit: contain;
    margin-top: 100px;
    margin-bottom: 80px;
  }

  div#ActivateAcc {
    width: 100%;
    border-radius: 0px;
    padding: 20px 0px 0px 10px;
    z-index: 99999;
    border: none;
}

.activate-drawer-bottom {
  margin: 0px 20px;
  position: absolute;
  bottom: 20px;
  right: 0;
  left: 0;
}

  p.sure-text {
    font-size: 18px;
  }

  svg.drawer-cross-icon{
    cursor: pointer;
    width: 32px;
    height: 32px;
  }

  .admin-sidebar-space {
    margin-left: 0px;
  }

  .activate-acc-wrap {
    margin: 0px 20px;
}

  .confirm-button-wrap button{
    height: 50px;
  }

  .customize-time-drawer-wrapper {
    margin: 0px 10px;
    padding-bottom: 70px;
  }
  
  .customize-time-wrap p {
    font-size: 16px;
  }
  
  .time-range-wrapper label {
    font-size: 18px;
  }
  
  .time-range-wrapper input{
    height: 60px;
  }
  
  .customize-security p {
    font-size: 14px;
  }
  
  .customize-btn button {
    width: 100%;
    height: 55px;
  }
  
  svg.drawer-cross-icon {
    cursor: pointer;
    width: 26px;
    height: 26px;
  }
}

@media (min-width: 768px) {
  .activate-acc-wrap p {
    font-size: 16px;
    text-align: left;
    color: #717171;
    margin-top: 16px;
  }
  .security-logo img {
    width: 150px;
    height: 150px;
    object-fit: contain;
    margin-top: 60px;
  }

  p.sure-text {
    font-size: 22px;
  }

  .principle-security {
    padding-bottom: 15px;
    border-bottom: 1px solid #ccc;
  }

  .activate-drawer-bottom {
    margin: 0px 50px;
    position: absolute;
    bottom: 10px;
    right: 0;
    left: 0;
}



.confirm-button-wrap button{
  height: 49px;
  font-size: 14px;
}

.twofa-status-drawer-wrapper{
  height: unset;
}

.twofa-status-drawer-wrapper img {
  width: 110px;
  height: auto;
}

.principle-security{
  margin-top: 40px;
}

.principle-security p {
  font-size: 16px;
  text-align: left;
}

.disable-twofa-input-wrap p {
  font-size: 18px;
  color: #717171;
}


}


@media (min-width: 768px) and (max-width:1599px) {

  div#customizeDatecanvasRight {
    width: 500px;
    border-radius: 24px 0px 0px 24px;
    padding: 20px 0px 0px 20px;
  }

  div#customizeDatecanvasRight .offcanvas-body {
    padding: 0px 10px;
  }

  .offcanvas-header {
    margin: 0px 30px;
  }

  .time-range-wrapper{
    height: unset;
    margin-top: 35px;
   }
   
   .customize-time-wrap p {
    font-size: 14px;
   }

   .customize-security img {
    width: 20px;
    height: 20px;
   }
   
   .time-range-wrapper input {
     width: 100%;
     height: 60px;
     font-size: 16px;
     color: #717171;
   }
   
   .time-range-wrapper h4 {
     font-size: 18px;
     padding: 15px 0px;
     padding-bottom: 5px;
   }
   
   .time-range-wrapper label {
     font-size: 18px;
     padding-bottom: 5px;
   }
   
   .customize-btn button {
     width: 100%;
     height: 58px;
   }
   
   .customize-time-drawer-wrapper {
     margin: 0px 30px;
   }

   div#ActivateAcc {
    width: 560px;
   }

   p.sure-text {
    font-size: 20px;
  }

  .security-logo img {
    width: 120px;
    height: 120px;
    margin-top: 100px;
  }
   
}

@media (min-width: 1600px) {
  .twofa-status-drawer-wrapper{
    height: calc(100vh - 350px);
  }

  .time-range-wrapper {
    height: calc(100vh - 480px);
  }

  .profile-icon img {
    width: 50px;
    height: 50px;
  }

  .wallet-drawer-wrapper {
    padding-bottom: 80px;
  }

  .profile-icon p {
    color: #383838;
    font-size: 24px;
  }

  .profile-content-wrap {
    min-height: calc(100vh - 240px);
    margin-top: 40px;
  }

  .profile-drawer-bottom button {
    font-size: 20px;
  }

  .profile-icon {
    display: flex;
    align-items: center;
    gap: 20px;
    margin-bottom: 38px;
  }

  .principle-open-drawer .table-header p {
    font-size: 16px;
  }

  .principle-open-drawer .table > :not(caption) > * > * {
    padding: 12px;
    font-size: 16px;
  }

  .principle-open-drawer .table > tbody td {
    color: #717171;
    text-align: center;
    font-size: 18px;
  }

  .profit-total-wrap h3 {
    font-size: 19px;
  }
  .profit-total-wrap p {
    font-size: 19px;
    font-weight: 300;
  }

  .total-profit h2 {
    font-size: 22px;
    color: #383838;
  }

  .total-profit-balance button {
    border: 2px solid transparent;
    background: var(--buttonBorder);
    background-origin: border-box;
    border-radius: 6px;
    box-shadow: inset 2px 1000px 1px #fff;
    font-size: 19px;
  }
  .time-range-wrapper input {
    width: 100%;
    padding: 11px 15px;
    font-size: 20px;
  }

  .time-range-wrapper label {
    font-size: 20px;
    text-align: left;
  }

  .time-range-wrapper h4 {
    font-size: 24px;
  }

  .customize-time-wrap p {
    font-size: 22px;
  }

  .customize-security p {
    font-size: 16px;
    margin: 0px;
    color: #9c9c9c;
  }

  .customize-btn button {
    font-size: 20px;
  }

  .overview-right h3 {
    font-size: 22px;
  }

  .overview-right p {
    font-size: 26px;
  }

  .overview-left h4 {
    font-size: 22px;
  }

  .wealth-transfer-right h3 {
    font-size: 22px;
  }

  .wealth-transfer-left h3 {
    font-size: 20px;
  }

  .wealth-transfer-right button {
    font-size: 20px;
    padding: 5px 20px;
  }

  .tranfer-manage-holder {
    width: 100%;
    height: 370px;
    padding: 20px;
    margin-top: 10px;
    position: relative;
  }

  .transfer-filter select {
    font-size: 18px;
  }
  .transfer-filter select {
    padding: 12px 10px;
    width: 175px;
  }

  .transfer-filter input {
    padding: 12px 10px;
    width: 175px;
  }

  .transfer-filter h3 {
    font-size: 20px;
    padding: 5px 0px;
    font-weight: 400;
  }

  .confirm-buttons button {
    position: absolute;
    left: 0;
    right: 0;
    margin: 0 auto;
    bottom: 30px;
    font-size: 20px;
    width: 130px;
  }

  .box-1,
  .box-2 {
    width: 20px;
    height: 20px;
  }
  .continue-wrap p {
    font-size: 17px;
    padding: 15px 0px;
  }

  .count-button p {
    font-size: 18px;
    margin-top: -2px;
  }

  .count-button {
    top: 51px;
  }

  .transfer-filter input {
    padding: 10px 10px;
    width: 175px;
    font-size: 16px;
  }
  .wealth-transfer-left span {
    font-size: 16px;
  }
  .wealth-transfer-left p {
    font-size: 18px;
  }

  .tranfer-manage-holder img {
    width: 20px;
  }

  .arrow svg {
    font-size: 27px;
  }
  .wealth-transfer-right h3:hover .wealth-hover {
    font-size: 22px;
    color: #ffd458;
  }

  .currency-box {
    width: 140px;
    height: 60px;
  }

  .principle-currency-wrap p {
    font-size: 20px;
  }

  .currency-box img {
    width: 38px;
    height: 38px;
  }

  .subscription-amount-wrap input {
    width: 100%;
    margin-top: 20px;
    height: 55px;
    font-size: 20px;
    border: 1.5px solid #ccc;
  }

  .subscription-amount-wrap p {
    padding: 20px 0px;
    font-size: 16px;
    font-weight: 300;
  }
  .principle-summary-wrapper h4 {
    font-size: 22px;
  }

  .time-box-wrap p {
    font-size: 18px;
    color: #383838;
  }

  .time-box,
  .date-box {
    width: 30px;
    height: 30px;
    border-radius: 3px;
  }

  .vartcal-line {
    height: 50px;
    width: 2px;
    background: #707070;
    text-align: center;
    margin-left: 14px;
  }

  .summary-time p {
    font-size: 16px;
    color: #858585;
  }
  .total-principle {
    margin-top: 40px;
    margin-bottom: 70px;
  }

  .principle-security {
    /* margin-top: 150px; */
    border-bottom: 2px solid #ccc;
    padding-bottom: 30px;
  }

  .principle-security p {
    font-size: 16px;
    color: #9c9c9c;
  }
  .procced-button button {
    margin-top: 30px;
    font-size: 20px;
  }

  .confirm-button-wrap button {
    font-size: 18px !important;
  }
  .overview-right span {
    font-size: 18px;
  }
  .principle-summary-wrapper {
    margin-top: 30px;
  }

  .principle-open-drawer .table-header {
    margin-top: -10px;
  }
  .profit-total-wrap {
    display: flex;
    justify-content: space-between;
  }
  .total-profit-wrapper {
    display: flex;
    justify-content: space-around;
    gap: 200px;
    margin-top: 15px;
    padding-bottom: 50px;
  }
  .profit-total-wrap {
    border-bottom: 2px solid #383838;
    width: 90%;
    margin: 0 auto;
    padding: 10px 0px;
  }
  .close-principle-drawer-footer {
    border-top: 1.5px solid #ccc;
  }
  .table-wrapper {
    height: calc(100vh - 360px) !important;
  }

  .activate-acc-wrap p {
    font-size: 24px;
    color: #717171;
    margin-top: 50px;
  }

  .principle-security p {
    font-size: 20px;
    color: #9c9c9c;
    text-align: left;
}

.activate-acc-wrap .security-logo {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 50vh;
}


.twofa-status-drawer-wrapper p {
  font-size: 38px;
}


.twofa-status-drawer-wrapper h2 {
  font-size: 50px;
}

.disable-twofa-input-wrap p {
  font-size: 24px;
  color: #717171;
}

.confirm-button-wrap button {
  height: 62px;
  font-size: 14px;
}
  
}

.customize-time-wrap {
  height: 100vh;
}

.table-wrapper thead {
  text-align: center;
}

.principle-open-drawer thead {
  text-align: center;
}

@media (min-width: 1920px) {
  .principle-open-drawer .table-header p {
    font-size: 18px;
  }

  .principle-open-drawer .table > :not(caption) > * > * {
    padding: 12px;
    font-size: 20px;
  }
  .principle-open-drawer .table > tbody td {
    font-size: 20px;
  }

  .profit-total-wrap h3 {
    font-size: 22px;
  }
  .profit-total-wrap p {
    font-size: 20px;
    font-weight: 400;
  }
  .total-profit h2 {
    font-size: 26px;
    color: #383838;
  }
  .total-profit-balance button {
    font-size: 20px;
  }
  .total-profit-balance {
    font-size: 20px;
  }

}

.principle-open-drawer .table > tbody td {
  font-size: 20px;
  border-left: none !important;
}

.principle-email {
  text-align: center;
  font-size: 18px;
  margin-top: -22px;
  margin-bottom: 25px;
}


p.date-error-message {
  font-size: 14px;
  color: red;
  margin: 6px;
}



/******************* New Drawer Css Start Here ***********/
.history-offcanvas-wrapper.offcanvas.offcanvas-end.show {
  width: 50%;
  box-shadow: -5px 0px 14px #0000000D;
  border-radius: 34px 0px 0px 34px;
  padding: 40px 0px 40px 40px;
  z-index: 99999;
}

.menu-offcanvas-wrapper.offcanvas.offcanvas-start.show {
width: 337px;
border: none;
z-index: 99999;
}


.notification-offcanvas-wrapper.offcanvas.offcanvas-end.show {
width: 775px;
box-shadow: -5px 0px 14px #0000000D;
border-radius: 34px 0px 0px 34px;
padding: 30px 20px 40px 40px;
z-index: 99999;
}


.chat-offcanvas-wrapper.offcanvas.offcanvas-end.show {
width: 725px;
box-shadow: -5px 0px 14px #0000000D;
border-radius: 34px 0px 0px 34px;
padding: 20px 20px 10px 40px;
z-index: 99999;
}

.service-offcanvas-wrapper.offcanvas.offcanvas-end.show {
width: 725px;
box-shadow: -5px 0px 14px #0000000D;
border-radius: 34px 0px 0px 34px;
padding: 20px 40px 10px 70px;
z-index: 99999;
}

.bankdetail-offcanvas-wrapper.offcanvas.offcanvas-end.show {
width: 622px;
box-shadow: -5px 0px 14px #0000000D;
border-radius: 34px 0px 0px 34px;
padding: 58px 32px 20px 32px;
z-index: 99999;
}

.availability-offcanvas-wrapper.offcanvas.offcanvas-end.show {
width: 725px;
box-shadow: -5px 0px 14px #0000000D;
border-radius: 34px 0px 0px 34px;
padding: 58px 0px 10px 70px;
z-index: 99999;
background: #fff;
}

.availability-offcanvas-wrapper .offcanvas-body {
padding-bottom: 0px;
margin-bottom: 20px;
}

.availability-offcanvas-wrapper .availability-input-wrapper {
display: flex;
align-items: center;
gap: 20px;
}

.availability-offcanvas-wrapper .availability-main-wrap {
gap: 24px;
}


.drawer-main-header-wrap {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
  padding-left: 20px;
  padding-right: 20px;
}


.drawer-main-header-wrap h4{
  font-size: 24px;
  color: #1A1919;
  font-weight: 600;
  margin: 0px;
}


.drawer-main-header-wrap img{
  cursor: pointer;
}


.history-list-drawer-table  thead {
  background-color: #00A19B08; /* Background color for thead */
}

.history-list-drawer-table .table.table-hover thead th  {
  padding: 10px; /* Optional padding */
  background-color: #00A19B08; /* Background color for each th */
}


.history-list-drawer-table .table-hover>tbody>tr:hover>* {
  --bs-table-color-state: unset !important;
  --bs-table-bg-state: unset !important;
}

.history-list-drawer-table tbody, td, tfoot, th, thead, tr {
  border-color: inherit;
  border-style: solid;
  border-width: 0;
  border: none;
}

.history-list-drawer-table thead th:first-child {
  border-top-left-radius: 15px; 
  border-bottom-left-radius: 15px;
}

.history-list-drawer-table thead th:last-child {
  border-top-right-radius: 15px; 
  border-bottom-right-radius: 15px;
}


.history-list-drawer-table .table.table-hover thead th {
  color: #383838;
  font-size: 20px;
}

.history-list-drawer-table .table tbody tr td {
  font-size: 18px;
  cursor: pointer;
}

.history-list-drawer-table .table.table-hover thead th {
  color: #383838;
  font-size: 18px;
  font-weight: 600;
  padding-left: 20px;
}

.history-list-drawer-table .table tbody tr td {
  color: #717171;
  font-size: 18px;
  white-space: nowrap;
  padding-left: 18px;
  vertical-align: middle;
}



/* .history-list-drawer-table .table-responsive {
  -webkit-overflow-scrolling: touch;
  height: 85vh;
  overflow-x: auto;
  overflow-y: auto;
} */

.history-item-images-wrapper {
  display: flex;
  align-items: center;
  gap: 22px;
}

.history-item-images-holder {
  display: flex;
}

.history-item-image-box {
  width: 38px;
  background: #f3f3f3;
  border-radius: 50%;
  margin-left: -14px;
  padding: 6px;
}

.history-item-images-holder img {
  width: 100%;
}

.history-item-images-wrapper img.main-image  {
  width: 50px;
}


.items-hold-wrap {
display: flex;
align-items: center;
gap: 0px;
}

.items-hold-wrap p {
width: 200px;
font-size: 18px;
color: #919191;
font-weight: 400;
margin: 0px;
text-overflow: ellipsis;
white-space: nowrap;
overflow: hidden;
}

.items-hold-wrap span{
font-size: 18px;
color: #00A19B;
font-weight: 400;
margin: 0px;

}

/************** Chat Masseges Drawer ****/
.replay-chat-box-wrapper {
position: relative;
margin-top: 20px;
width: 100%;
height: calc(100vh - 170px);
}


/******** Chat Bot Msg *****/
.msger-chat {
  flex: 1 1;
  overflow-y: auto;
  padding: 20px 20px;
  height: calc(100vh - 260px);
}

.msger-chat::-webkit-scrollbar {
  width: 5px;
  border-radius: 10px;
  
}

.msger-chat::-webkit-scrollbar-track {
  background: #ddd;
}

.msger-chat::-webkit-scrollbar-thumb {
  background: #00A19B;
}

.msg {
  display: flex;
  align-items: flex-end;
}

.msg:last-of-type {
  margin: 0;
}

.msg-bubble {
  max-width: 450px;
  padding: 15px;
  border-radius: 25px;
  background: #BAE9E9;
}

.msg-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}

.msg-info-name {
  font-size: 14px;
  color: #313131;
  font-weight: 500;
  margin-left: 20px;
}

.msg-info-time {
  font-size: 0.85em;
}



.right-msg {
  flex-direction: row-reverse;
}

.right-msg .msg-bubble {
  background: #00A19B;
  color: #fff;
  border-radius: 25px;
}

.replay-chat-box-wrap .msg.left-msg .msg-text {
  font-size: 16px;
  color: #1A1919;
  font-weight: 600;
  margin: 0px;
}

.replay-chat-box-wrap .msg .msg-text {
font-size: 16px;
color: #FFFFFF;
font-weight: 600;
margin: 0px;
}

.chat-right-message-wrap .msg-info-time p {
  font-size: 14px;
  color: #B5B5B5;
  font-weight: 400;
  margin: 0px;
  text-align: right;
  padding-right: 10px;
}

.chat-left-message-wrap .msg-info-time p {
  font-size: 14px;
  color: #B5B5B5;
  font-weight: 400;
  margin: 0px;
  padding-right: 10px;
}

.chat-right-message-wrap{
  margin-bottom: 16px;
}


.right-info-time {
  text-align: right;
}

.left-info-time {
  text-align: left;
}

.right-info-time p, .left-info-time p {
font-size: 14px;
color: #B5B5B5;
font-weight: 400;
padding-top: 4px;
margin-left: 20px;
margin-right: 20px;
}



.chat-send-message-wrapper{
position: absolute;
width: 100%;
bottom: 0px;
}


.chat-send-message-wrap{
position: relative;
}

.chat-send-message-wrap input {
width: 100%;
height: 82px;
border: 1px solid #DFDFDF;
border-radius: 42px;
outline: none;
padding: 30px;
}

.chat-send-button img {
width: 65px;
position: absolute;
top: 10px;
right: 10px;
cursor: pointer;
}


.chat-date-divider {
width: 80%;
border: 1px solid #E9E9E9;
height: 0px;
display: flex;
align-items: center;
justify-content: center;
margin: 0 auto;
margin-top: 26px;
margin-bottom: 34px;
}

.chat-date-divider span {
display: block;
background: #fff;
padding: 0px 20px;
color: #B5B5B5;
font-size: 14px;
font-weight: 400;
}


.notification-drawer-header h3 {
font-size: 24px;
color: #1A1919;
font-weight: 600;
margin: 0px;
}

.notification-drawer-header {
display: flex;
align-items: center;
justify-content: space-between;
position: sticky;
top: 0;
background: #fff;
padding-top: 20px;
}

.notification-drawer-header img{
width: 38px;
cursor: pointer;
}


.noting-found-main-wrap img {
width: 112px;
margin-bottom: 10px;
}

.noting-found-main-wrap p {
font-size: 24px;
color: #B2B2B2;
margin: 0px;
font-weight: 400;
}


.noting-found-main-wrap {
display: flex;
flex-direction: column;
justify-content: center;
align-items: center;
height: calc(100vh - 200px);
}

.nothing-found-cart-wrap{
height: calc(100vh - 210px);
}

.cleaner-partner.right {
display: none;
}

.cleaner-partner.left{
font-size: 18px;
color: #1A1919;
font-weight: 400;
margin: 0px;
margin-bottom: 4px;
}


.empty-conversation-wrap {
display: flex;
align-items: center;
justify-content: center;
flex-direction: column;
height: calc(100vh - 260px);
}

.empty-conversation-wrap h3 {
font-size: 25px;
color: #1A1919;
font-weight: bold;
margin: 0px;
}

.empty-conversation-wrap p {
font-size: 22px;
color: #1A1919;
font-weight: 400;
text-align: center;
width: 60%;
padding-top: 10px;
}

.empty-conversation-wrap img {
width: 150px;
}


/**************** Service Drawer css ********/
.service-drawer-header {
display: flex;
align-items: center;
justify-content: space-between;
margin-bottom: 54px;
}

.service-drawer-header h3 {
font-size: 24px;
color: #1A1919;
font-weight: 600;
margin: 0px;
}

.service-drawer-header img {
width: 36px;
cursor: pointer;
}

.service-drawer-main-wrapper button.accordion-button img {
width: 74px;
margin-right: 10px;
}

.service-drawer-main-wrapper button.accordion-button p {
font-size: 18px;
color: #1A1919;
margin: 0px;
font-weight: 400;
margin-top: 10px;
}

.service-drawer-main-wrapper .commerical-services-wrap h4 {
font-size: 18px;
}

.service-drawer-main-wrapper .checkbox-container {
  font-size: 16px;
  padding-left: 50px;
  margin-bottom: 16px;
}

.service-drawer-main-wrapper .checkbox-container .checkmark {
  height: 24px;
  width: 24px;
}

.service-drawer-main-wrapper .commerical-services-wrap {
padding: 14px 20px;
}

.profile-service-drawer-wrapper .commerical-services-wrap {
padding: 16px 46px;
}

.service-drawer-main-wrapper .specail-service-commerical-wrapper {
width: 95%;
/* margin: 0 auto; */
}

.bussiness-location-btn.service-edit-button {
width: 95%;
margin-top: 160px;
}

.service-drawer-head-left p{
font-size: 14px;
color: #1A1919;
font-weight: 400;
margin: 0px;
}

.service-drawer-head-left p span{
color: #9ea1f3;
}

.profile-service-drawer-header{
align-items: baseline;
}

/********************* Bank Detail Drawer css ******/
.bank-detail-drawer-form {
margin-top: 100px;
}

.bank-detail-drawer-btn{
margin-top: 100px;
}

.bank-detail-drawer-form  .field {
margin-bottom: 30px;
}

.bank-detail-drawer-form .login-option input {
width: 100%;
height: 80px;
font-size: 18px;
font-weight: 500;
}

.bank-detail-head-contant p {
font-size: 16px;
color: #8A8A8A;
font-weight: 400;
margin: 0px;
}

.bank-cheque-image-wrap {
margin-top: 130px;
}

.cheque-edit-state{
margin-top: 85px;
}

.bank-cheque-image-wrap img {
width: 100%;
}

.bank-detail-drawer-btn{
width: 530px;
bottom: 60px;
}


.bank-check-upload-wrap {
width: 80%;
margin: 0 auto;
margin-top: 50px;
}

.cheque-status-wrap {
display: flex;
align-items: center;
justify-content: space-between;
background: #F3F3F3;
height: 87px;
border-radius: 17px;
padding: 0px 40px;
position: fixed;
bottom: 140px;
width: 530px;
}


.cheque-status-left h3 {
font-size: 14px;
color: #1A1919;
font-weight: 600;
margin: 0px;
}

.cheque-status-right{
display: flex;
gap: 4px;
align-items: center;
}

.cheque-status-right img{
width: 30px;
}

.cheque-status-right p {
font-size: 14px;
color: #00A19B;
font-weight: 500;
margin: 0px;
}

.bank-cheque-edit-wrap{
display: flex;
align-items: center;
justify-content: flex-end;
gap: 16px;
margin-bottom: 20px;
}

.bank-cheque-edit-wrap h3{
font-size: 22px;
color: #1A1919;
font-weight: 600;
margin: 0px;
}

.bank-cheque-edit-wrap img{
width: 24px;
cursor: pointer;
}

p.edit-cheque-info-text {
font-size: 14px;
color: #707070;
margin-top: 8px;
margin: 0px;
margin-top: 8px;
}



/**************** Availability Drawer css ********/
.availability-drawer-main-wrapper .availability-day-wrap {
width: 74px;
height: 74px;
}

.availability-drawer-main-wrapper .availability-day-wrap h3 {
font-size: 24px;
}

.availability-drawer-main-wrapper .availability-input-left-wrap input {
width: 180px;
height: 64px;
border-radius: 18px;
}

.availability-drawer-main-wrapper .availability-input-wrapper p {
font-size: 16px;
color: #1A1919;
font-weight: 500;
}

.availability-drawer-main-wrapper .plus-icon-wrap img, .minus-icon-wrap img {
width: 65px;
cursor: pointer;
}

.availability-drawer-main-wrapper .availability-input-left-wrap input {
font-size: 18px;
font-weight: 600;
}

.availability-drawer-main-wrapper .availability-input-repeat {
gap: 32px;
}

.availability-drawer-main-wrapper  .availability-main-wrap {
margin-bottom: 32px;
}


.availability-drawer-main-wrapper .signup-availibty-save-btn{
position: sticky;
bottom: 0px;
background: #fff;
padding-right: 20px;
}

.availability-drawer-main-wrapper .signup-availibty-save-btn button {
margin-top: 30px;
height: 64px;
}

.availability-main-wrapper {
overflow-y: auto !important;
height: calc(100vh - 320px);
padding-right: 20px;
}


/*********** Menu Drawer Css *******/

.menu-drawer-header {
display: flex;
align-items: center;
justify-content: space-between;
height: 70px;
padding: 0px 20px;
background: #00A19B;
width: 100%;
}

.menu-drawer-header .nav-review-stars svg {
width: 18px;
}

.menu-drawer-left {
display: flex;
align-items: center;
gap: 0px;
}

.menu-header-profile img {
width: 67px;
}

.menu-contractor-detail h3 {
font-size: 18px;
color: #FFFFFF;
font-weight: 600;
margin: 0px;
}

.menu-contractor-detail p {
  font-size: 14px;
  color: #FFFFFF;
  font-weight: 400;
  margin: 0px;
  width: 240px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.menu-offcanvas-wrapper .offcanvas-body{
padding: 0px;
}

.menu-drawer-header .menu-drawer-right img {
  width: 30px;
  cursor: pointer;
}

/* .menu-drawer-main-wrap{
padding: 20px 0px;
} */

.menu-drawer-tab-wrap {
  display: flex;
  align-items: center;
  gap: 22px;
  cursor: pointer;
}

.menu-drawer-tab-wrap img {
  width: 35px;
  display: none;
}

.menu-drawer-tab-repeat {
border-bottom: 2px solid #F3F3F3;
padding: 26px 24px
}

.menu-drawer-tab-wrap p {
font-size: 16px;
color: #1A1919;
font-weight: 600;
margin: 0px;
}

.menu-drawer-tab-repeat:hover .menu-drawer-tab-wrap p {
color: #00A19B;
}

.status-drawer-close-icon {
position: absolute;
right: 20px;
top: 50px;
}

img.remove-delete-icon{
display: none;
}

/******* Resposive css ****/
@media (max-width: 767px) {
.history-offcanvas-wrapper.offcanvas.offcanvas-end.show {
  width: 100%;
  box-shadow: -5px 0px 14px #0000000D;
  border-radius: 0px;
  padding: 30px 0px 30px 0px;
  z-index: 99999;
}

.empty-conversation-wrap p {
  width: 100%;
}

.chat-offcanvas-wrapper.offcanvas.offcanvas-end.show {
  border-radius: 0px;
  padding: 20px;
}

.chat-date-divider {
  width: 100%;
}

.replay-chat-box-wrapper {
  margin-top: 10px;
}

.msger-chat {
  padding: 10px 0px;
}

.empty-conversation-wrap h3 {
  font-size: 22px;
}

.empty-conversation-wrap p {
  font-size: 20px;
}

.empty-conversation-wrap img {
  width: 120px;
}

.notification-drawer-header img {
  width: 34px;
}

.availability-offcanvas-wrapper.offcanvas.offcanvas-end.show {
  width: 100%;
  box-shadow: -5px 0px 14px #0000000D;
  border-radius: 0px;
  padding: 58px 0px 10px 10px;
}

.service-drawer-header h3 {
  font-size: 22px;
}

.bank-detail-head-contant p {
  font-size: 14px;
}

.availability-drawer-main-wrapper .availability-day-wrap {
  width: 38px;
  height: 38px;
}

.availability-drawer-main-wrapper .availability-day-wrap h3 {
  font-size: 12px;
}

.availability-drawer-main-wrapper .availability-input-left-wrap input {
  width: 106px;
  height: 40px;
  border-radius: 9px;
  font-size: 12px;
}

.availability-drawer-main-wrapper .availability-input-wrapper p {
  font-size: 12px;
}

.availability-offcanvas-wrapper .availability-input-wrapper {
  gap: 10px;
}

.availability-drawer-main-wrapper .plus-icon-wrap img, .minus-icon-wrap img {
  width: 37px;
}

.availability-offcanvas-wrapper .availability-main-wrap {
  gap: 18px;
}


.availability-offcanvas-wrapper .offcanvas-body {
padding-right: 0px;
}

.availability-main-wrapper {
overflow-y: auto !important;
height: calc(100vh - 320px);
padding-right: 0px;
}

.availability-drawer-main-wrapper .signup-availibty-save-btn button {
margin-top: 10px;
height: 49px;
}

.bankdetail-offcanvas-wrapper.offcanvas.offcanvas-end.show {
width: 100%;
border-radius: 0px;
padding: 58px 12px 20px 14px;
}

.drawer-close-icon-wrap img {
width: 34px;
}

.bank-cheque-image-wrap {
margin-top: 100px;
}

.bank-detail-drawer-btn {
width: 100%;
bottom: 20px;
}

.bank-detail-drawer-btn button{
height: 49px;
font-size: 14px;
}

.cheque-status-wrap {
display: flex;
align-items: center;
justify-content: space-between;
background: #F3F3F3;
height: 48px;
border-radius: 9px;
padding: 0px 20px;
position: fixed;
bottom: 110px;
width: 86%;
}

.cheque-status-right p {
font-size: 12px;
}

.bank-cheque-edit-wrap h3 {
font-size: 14px;
}

.bank-cheque-edit-wrap img {
width: 15px;
}

.bank-cheque-edit-wrap {
gap: 10px;
margin-bottom: 10px;
}

.cheque-edit-state {
margin-top: 80px;
}


p.edit-cheque-info-text {
font-size: 12px;
}

.bank-check-upload-wrap {
width: 86%;
}

.bank-check-upload-wrap .certificate-upload-box {
height: 48px;
}

.drawer-close-icon-wrap img {
width: 34px;
}

.service-drawer-main-wrapper .commerical-services-wrap h4 {
font-size: 14px;
}

.profile-commerical-services-select-wrap p, .profile-commerical-speciality-select-wrap p {
font-size: 12px;
}

.profile-service-drawer-wrapper .commerical-services-wrap {
padding: 16px 20px;
}

.profile-commerical-services-select-wrap {
display: grid;
grid-template-columns: repeat(3, 1fr);
}

.profile-commerical-speciality-select-wrap {
display: grid;
grid-template-columns: repeat(2, 1fr);
gap: 6px;
}

.profile-commerical-speciality-select-wrap p{
margin-bottom: 10px;
}

.service-drawer-main-wrapper button.accordion-button img {
width: 56px;
}

.service-drawer-main-wrapper button.accordion-button p {
font-size: 16px;
}

.accordion-item {
margin-top: 32px;
}

.drawer-close-icon-wrap {
position: absolute;
right: 30px;
top: 30px;
}

.service-drawer-head-left p {
width: 90%;
}

.service-drawer-header {
margin-bottom: 40px;
}

.cheque-status-right img {
width: 20px;
}


}


@media (max-width: 360px) {
.availability-drawer-main-wrapper .availability-input-left-wrap input {
  width: 100px;
}

.availability-offcanvas-wrapper .availability-main-wrap {
  gap: 10px;
}

.bank-detail-head-contant p {
  font-size: 12px;
}

.service-drawer-header h3 {
  font-size: 20px;
}

.menu-contractor-detail p {
  width: 200px;
}

}

@media (min-width: 768px) and (max-width: 1024px) {
.availability-offcanvas-wrapper.offcanvas.offcanvas-end.show {
  width: 532px;
  box-shadow: -5px 0px 14px #0000000D;
  border-radius: 34px 0px 0px 34px;
  padding: 35px 0px 10px 32px;
  z-index: 99999;
  background: #fff;
}

.service-drawer-header h3 {
font-size: 18px;
padding-bottom: 6px;
}

.bank-detail-head-contant p {
font-size: 14px;
}

.availability-drawer-main-wrapper .availability-day-wrap {
width: 47px;
height: 47px;
}

.availability-drawer-main-wrapper .availability-input-left-wrap input {
width: 135px;
height: 48px;
border-radius: 9px;
font-size: 14px;
}

.availability-drawer-main-wrapper .plus-icon-wrap img, .minus-icon-wrap img {
width: 47px;
}

.availability-drawer-main-wrapper .availability-input-wrapper p {
font-size: 14px;
}

.availability-drawer-main-wrapper .availability-main-wrap {
margin-bottom: 22px;
gap: 18px;
}

.availability-drawer-main-wrapper .availability-day-wrap h3 {
font-size: 14px;
}

.availability-drawer-main-wrapper .signup-availibty-save-btn button {
margin-top: 30px;
height: 49px;
}

.service-drawer-header {
margin-bottom: 34px;
}

.availability-main-wrapper {
height: calc(100vh - 260px);
}


.bankdetail-offcanvas-wrapper.offcanvas.offcanvas-end.show {
width: 520px;
padding: 35px 26px 20px 26px;
}

.bank-cheque-image-wrap {
margin-top: 60px;
}

.bank-detail-drawer-btn {
width: 430px;
bottom: 50px;
margin-top: 80px;
}


.bank-cheque-edit-wrap h3 {
font-size: 14px;
}

.bank-cheque-edit-wrap img {
width: 16px;
}

.bank-cheque-edit-wrap {
gap: 10px;
margin-bottom: 12px;
}

.cheque-status-wrap {
width: 430px;
height: 48px;
border-radius: 9px;
padding: 0px 40px;
bottom: 120px;
}

.cheque-edit-state {
margin-top: 20px;
}

.cheque-status-left h3 {
font-size: 12px;
}

.cheque-status-right p {
font-size: 12px;
}


.service-drawer-main-wrapper button.accordion-button img {
width: 52px;
}

.service-drawer-main-wrapper button.accordion-button p {
font-size: 16px;
}

.service-drawer-main-wrapper .accordion-item .accordion-header .accordion-button {
padding: 10px 20px;
height: 76px;
}

.service-drawer-main-wrapper .commerical-services-wrap h4 {
font-size: 14px;
}

.profile-commerical-services-select-wrap p, .profile-commerical-speciality-select-wrap p {
font-size: 12px;
}

.cheque-status-right img {
width: 20px;
}

}


@media (min-width: 1025px) and (max-width: 1599px) {
.availability-offcanvas-wrapper.offcanvas.offcanvas-end.show {
  width: 580px;
  box-shadow: -5px 0px 14px #0000000D;
  border-radius: 34px 0px 0px 34px;
  padding: 35px 0px 10px 32px;
  z-index: 99999;
  background: #fff;
}

.service-drawer-main-wrapper .checkbox-container {
  font-size: 14px;
  padding-left: 36px;
  margin-bottom: 16px;
}

.service-drawer-header h3 {
font-size: 18px;
padding-bottom: 6px;
}

.bank-detail-head-contant p {
font-size: 14px;
}

.availability-drawer-main-wrapper .availability-day-wrap {
width: 47px;
height: 47px;
}

.availability-drawer-main-wrapper .availability-input-left-wrap input {
width: 150px;
height: 48px;
border-radius: 9px;
font-size: 14px;
}

.availability-drawer-main-wrapper .plus-icon-wrap img, .minus-icon-wrap img {
width: 47px;
}

.availability-drawer-main-wrapper .availability-input-wrapper p {
font-size: 14px;
}

.availability-drawer-main-wrapper .availability-main-wrap {
margin-bottom: 22px;
gap: 18px;
}

.availability-drawer-main-wrapper .availability-day-wrap h3 {
font-size: 14px;
}

.availability-drawer-main-wrapper .signup-availibty-save-btn button {
margin-top: 30px;
height: 49px;
}

.service-drawer-header {
margin-bottom: 34px;
}

.availability-main-wrapper {
height: calc(100vh - 260px);
}


.bankdetail-offcanvas-wrapper.offcanvas.offcanvas-end.show {
width: 520px;
padding: 35px 26px 20px 26px;
}

.bank-cheque-image-wrap {
margin-top: 60px;
}

.bank-detail-drawer-btn {
width: 430px;
bottom: 40px;
margin-top: 80px;
}

.bank-cheque-edit-wrap h3 {
font-size: 14px;
}

.bank-cheque-edit-wrap img {
width: 16px;
}

.bank-cheque-edit-wrap {
gap: 10px;
margin-bottom: 12px;
}

.cheque-status-wrap {
width: 430px;
height: 48px;
border-radius: 9px;
padding: 0px 40px;
bottom: 100px;
}

.cheque-edit-state {
margin-top: 20px;
}

.cheque-status-left h3 {
font-size: 12px;
}

.cheque-status-right p {
font-size: 12px;
}

.service-drawer-head-left p {
font-size: 12px;
}

.signup-special-services-wrap {
margin-top: 20px;
}

.service-drawer-main-wrapper button.accordion-button img {
width: 52px;
}

.service-drawer-main-wrapper button.accordion-button p {
font-size: 16px;
}

.service-drawer-main-wrapper .accordion-item .accordion-header .accordion-button {
padding: 10px 20px;
height: 76px;
}

.service-drawer-main-wrapper .commerical-services-wrap h4 {
font-size: 14px;
}

.profile-commerical-services-select-wrap p, .profile-commerical-speciality-select-wrap p {
font-size: 12px;
}

p.edit-cheque-info-text {
font-size: 12px;
}

.cheque-status-right img {
width: 20px;
}
}




@media (min-width: 1025px) and (max-width: 1199px) {

}

`, "",{"version":3,"sources":["webpack://./src/Dashboard/Drawers/Drawer.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,mCAAmC;EACnC,gCAAgC;EAChC,8BAA8B;EAC9B,0BAA0B;EAC1B,cAAc;EACd,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,mCAAmC;EACnC,gCAAgC;EAChC,8BAA8B;EAC9B,0BAA0B;EAC1B,cAAc;EACd,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,8BAA8B;EAC9B,kBAAkB;EAClB,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,0BAA0B;EAC1B,aAAa;AACf;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,cAAc;EACd,aAAa;EACb,UAAU;EACV,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,uBAAuB;EACvB,qCAAqC;EACrC,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,kCAAkC;EAClC,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;;;GAGG;;AAEH;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,UAAU;EACV,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,cAAc;EACd,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,+BAA+B;EAC/B,+BAA+B;EAC/B,6BAA6B;EAC7B,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA,kCAAkC;AAClC;EACE,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,WAAW;AACb;;AAEA;EACE,UAAU;EACV,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,cAAc;AAChB;;AAEA;;;;GAIG;;AAEH;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,UAAU;EACV,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,gBAAgB;AAClB;;;AAGA;EACE,eAAe;EACf,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,sCAAsC;EACtC,mBAAmB;EACnB,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,gCAAgC;;AAEhC;EACE,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,WAAW;AACb;;AAEA;EACE,8BAA8B;EAC9B,oBAAoB;AACtB;;AAEA;EACE,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,iCAAiC;EACjC,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,oCAAoC;EACpC,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,iBAAiB;EACjB,oCAAoC;EACpC,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;;AAGA,2CAA2C;AAC3C;EACE,aAAa;EACb,yBAAyB;EACzB,uBAAuB;EACvB,sBAAsB;EACtB,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,uBAAuB;EACvB,WAAW;EACX,cAAc;EACd,SAAS;EACT,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;;AAGA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iCAAiC;AACnC;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;AACjC;;AAEA,iCAAiC;AACjC;EACE,kBAAkB;EAClB,mBAAmB;EACnB,oCAAoC;EACpC,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,SAAS;EACT,eAAe;EACf,2BAA2B;EAC3B,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA,8CAA8C;AAC9C;EACE,wBAAwB;EACxB,gBAAgB;AAClB;;;AAGA;EACE,kBAAkB;AACpB;;;AAGA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,iBAAiB;AACnB;;;AAGA;EACE,gBAAgB;AAClB;;;AAGA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,2BAA2B;EAC3B,kBAAkB;AACpB;;;AAGA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;;EAEE;IACE,gBAAgB;EAClB;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,6BAA6B;EAC/B;;EAEA;IACE,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,eAAe;EACjB;EACA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,kBAAkB;IAClB,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,cAAc;EAChB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,0BAA0B;IAC1B,cAAc;IACd,YAAY;AAChB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,QAAQ;EACR,OAAO;AACT;;EAEE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,WAAW;IACX,YAAY;EACd;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;AACpB;;EAEE;IACE,YAAY;EACd;;EAEA;IACE,gBAAgB;IAChB,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;IACf,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE;IACE,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,gBAAgB;EAClB;EACA;IACE,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,oBAAoB;IACpB,6BAA6B;EAC/B;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;IACZ,QAAQ;IACR,OAAO;AACX;;;;AAIA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;;AAGA;;;AAGA;;EAEE;IACE,YAAY;IACZ,gCAAgC;IAChC,0BAA0B;EAC5B;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,gBAAgB;GACjB;;GAEA;IACC,eAAe;GAChB;;GAEA;IACC,WAAW;IACX,YAAY;GACb;;GAEA;KACE,WAAW;KACX,YAAY;KACZ,eAAe;KACf,cAAc;GAChB;;GAEA;KACE,eAAe;KACf,iBAAiB;KACjB,mBAAmB;GACrB;;GAEA;KACE,eAAe;KACf,mBAAmB;GACrB;;GAEA;KACE,WAAW;KACX,YAAY;GACd;;GAEA;KACE,gBAAgB;GAClB;;GAEA;IACC,YAAY;GACb;;GAEA;IACC,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,iBAAiB;EACnB;;AAEF;;AAEA;EACE;IACE,2BAA2B;EAC7B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,+BAA+B;IAC/B,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;EACA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,6BAA6B;IAC7B,+BAA+B;IAC/B,6BAA6B;IAC7B,kBAAkB;IAClB,qCAAqC;IACrC,eAAe;EACjB;EACA;IACE,WAAW;IACX,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,WAAW;IACX,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,aAAa;IACb,aAAa;IACb,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;EACA;IACE,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,cAAc;IACd,YAAY;IACZ,eAAe;IACf,YAAY;EACd;;EAEA;;IAEE,WAAW;IACX,YAAY;EACd;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;EACA;IACE,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,wBAAwB;EAC1B;;EAEA;IACE,iBAAiB;IACjB,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,cAAc;EAChB;;EAEA;;IAEE,WAAW;IACX,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,YAAY;IACZ,UAAU;IACV,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,cAAc;EAChB;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,uBAAuB;IACvB,6BAA6B;IAC7B,oBAAoB;EACtB;;EAEA;IACE,eAAe;IACf,cAAc;EAChB;EACA;IACE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;EACA;IACE,aAAa;IACb,8BAA8B;EAChC;EACA;IACE,aAAa;IACb,6BAA6B;IAC7B,UAAU;IACV,gBAAgB;IAChB,oBAAoB;EACtB;EACA;IACE,gCAAgC;IAChC,UAAU;IACV,cAAc;IACd,iBAAiB;EACnB;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,sCAAsC;EACxC;;EAEA;IACE,eAAe;IACf,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;;;AAGA;EACE,eAAe;AACjB;;;AAGA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,eAAe;EACjB;EACA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;EACA;IACE,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,cAAc;EAChB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;;AAEF;;AAEA;EACE,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;;;AAGA;EACE,eAAe;EACf,UAAU;EACV,WAAW;AACb;;;;AAIA,0DAA0D;AAC1D;EACE,UAAU;EACV,mCAAmC;EACnC,gCAAgC;EAChC,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;AACA,YAAY;AACZ,YAAY;AACZ,cAAc;AACd;;;AAGA;AACA,YAAY;AACZ,mCAAmC;AACnC,gCAAgC;AAChC,4BAA4B;AAC5B,cAAc;AACd;;;AAGA;AACA,YAAY;AACZ,mCAAmC;AACnC,gCAAgC;AAChC,4BAA4B;AAC5B,cAAc;AACd;;AAEA;AACA,YAAY;AACZ,mCAAmC;AACnC,gCAAgC;AAChC,4BAA4B;AAC5B,cAAc;AACd;;AAEA;AACA,YAAY;AACZ,mCAAmC;AACnC,gCAAgC;AAChC,4BAA4B;AAC5B,cAAc;AACd;;AAEA;AACA,YAAY;AACZ,mCAAmC;AACnC,gCAAgC;AAChC,2BAA2B;AAC3B,cAAc;AACd,gBAAgB;AAChB;;AAEA;AACA,mBAAmB;AACnB,mBAAmB;AACnB;;AAEA;AACA,aAAa;AACb,mBAAmB;AACnB,SAAS;AACT;;AAEA;AACA,SAAS;AACT;;;AAGA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;;AAGA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,WAAW;AACb;;;AAGA;EACE,eAAe;AACjB;;;AAGA;EACE,2BAA2B,EAAE,+BAA+B;AAC9D;;AAEA;EACE,aAAa,EAAE,qBAAqB;EACpC,2BAA2B,EAAE,iCAAiC;AAChE;;;AAGA;EACE,wCAAwC;EACxC,qCAAqC;AACvC;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,6BAA6B;EAC7B,gCAAgC;AAClC;;;AAGA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;AACxB;;;;AAIA;;;;;GAKG;;AAEH;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;;AAGA;AACA,aAAa;AACb,mBAAmB;AACnB,QAAQ;AACR;;AAEA;AACA,YAAY;AACZ,eAAe;AACf,cAAc;AACd,gBAAgB;AAChB,WAAW;AACX,uBAAuB;AACvB,mBAAmB;AACnB,gBAAgB;AAChB;;AAEA;AACA,eAAe;AACf,cAAc;AACd,gBAAgB;AAChB,WAAW;;AAEX;;AAEA,yCAAyC;AACzC;AACA,kBAAkB;AAClB,gBAAgB;AAChB,WAAW;AACX,2BAA2B;AAC3B;;;AAGA,4BAA4B;AAC5B;EACE,SAAO;EACP,gBAAgB;EAChB,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,UAAU;EACV,mBAAmB;;AAErB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;;;AAIA;EACE,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,WAAW;AACb;;AAEA;AACA,eAAe;AACf,cAAc;AACd,gBAAgB;AAChB,WAAW;AACX;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;;AAGA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;AACA,eAAe;AACf,cAAc;AACd,gBAAgB;AAChB,gBAAgB;AAChB,iBAAiB;AACjB,kBAAkB;AAClB;;;;AAIA;AACA,kBAAkB;AAClB,WAAW;AACX,WAAW;AACX;;;AAGA;AACA,kBAAkB;AAClB;;AAEA;AACA,WAAW;AACX,YAAY;AACZ,yBAAyB;AACzB,mBAAmB;AACnB,aAAa;AACb,aAAa;AACb;;AAEA;AACA,WAAW;AACX,kBAAkB;AAClB,SAAS;AACT,WAAW;AACX,eAAe;AACf;;;AAGA;AACA,UAAU;AACV,yBAAyB;AACzB,WAAW;AACX,aAAa;AACb,mBAAmB;AACnB,uBAAuB;AACvB,cAAc;AACd,gBAAgB;AAChB,mBAAmB;AACnB;;AAEA;AACA,cAAc;AACd,gBAAgB;AAChB,iBAAiB;AACjB,cAAc;AACd,eAAe;AACf,gBAAgB;AAChB;;;AAGA;AACA,eAAe;AACf,cAAc;AACd,gBAAgB;AAChB,WAAW;AACX;;AAEA;AACA,aAAa;AACb,mBAAmB;AACnB,8BAA8B;AAC9B,gBAAgB;AAChB,MAAM;AACN,gBAAgB;AAChB,iBAAiB;AACjB;;AAEA;AACA,WAAW;AACX,eAAe;AACf;;;AAGA;AACA,YAAY;AACZ,mBAAmB;AACnB;;AAEA;AACA,eAAe;AACf,cAAc;AACd,WAAW;AACX,gBAAgB;AAChB;;;AAGA;AACA,aAAa;AACb,sBAAsB;AACtB,uBAAuB;AACvB,mBAAmB;AACnB,2BAA2B;AAC3B;;AAEA;AACA,2BAA2B;AAC3B;;AAEA;AACA,aAAa;AACb;;AAEA;AACA,eAAe;AACf,cAAc;AACd,gBAAgB;AAChB,WAAW;AACX,kBAAkB;AAClB;;;AAGA;AACA,aAAa;AACb,mBAAmB;AACnB,uBAAuB;AACvB,sBAAsB;AACtB,2BAA2B;AAC3B;;AAEA;AACA,eAAe;AACf,cAAc;AACd,iBAAiB;AACjB,WAAW;AACX;;AAEA;AACA,eAAe;AACf,cAAc;AACd,gBAAgB;AAChB,kBAAkB;AAClB,UAAU;AACV,iBAAiB;AACjB;;AAEA;AACA,YAAY;AACZ;;;AAGA,6CAA6C;AAC7C;AACA,aAAa;AACb,mBAAmB;AACnB,8BAA8B;AAC9B,mBAAmB;AACnB;;AAEA;AACA,eAAe;AACf,cAAc;AACd,gBAAgB;AAChB,WAAW;AACX;;AAEA;AACA,WAAW;AACX,eAAe;AACf;;AAEA;AACA,WAAW;AACX,kBAAkB;AAClB;;AAEA;AACA,eAAe;AACf,cAAc;AACd,WAAW;AACX,gBAAgB;AAChB,gBAAgB;AAChB;;AAEA;AACA,eAAe;AACf;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;AACA,kBAAkB;AAClB;;AAEA;AACA,kBAAkB;AAClB;;AAEA;AACA,UAAU;AACV,oBAAoB;AACpB;;AAEA;AACA,UAAU;AACV,iBAAiB;AACjB;;AAEA;AACA,eAAe;AACf,cAAc;AACd,gBAAgB;AAChB,WAAW;AACX;;AAEA;AACA,cAAc;AACd;;AAEA;AACA,qBAAqB;AACrB;;AAEA,oDAAoD;AACpD;AACA,iBAAiB;AACjB;;AAEA;AACA,iBAAiB;AACjB;;AAEA;AACA,mBAAmB;AACnB;;AAEA;AACA,WAAW;AACX,YAAY;AACZ,eAAe;AACf,gBAAgB;AAChB;;AAEA;AACA,eAAe;AACf,cAAc;AACd,gBAAgB;AAChB,WAAW;AACX;;AAEA;AACA,iBAAiB;AACjB;;AAEA;AACA,gBAAgB;AAChB;;AAEA;AACA,WAAW;AACX;;AAEA;AACA,YAAY;AACZ,YAAY;AACZ;;;AAGA;AACA,UAAU;AACV,cAAc;AACd,gBAAgB;AAChB;;AAEA;AACA,aAAa;AACb,mBAAmB;AACnB,8BAA8B;AAC9B,mBAAmB;AACnB,YAAY;AACZ,mBAAmB;AACnB,iBAAiB;AACjB,eAAe;AACf,aAAa;AACb,YAAY;AACZ;;;AAGA;AACA,eAAe;AACf,cAAc;AACd,gBAAgB;AAChB,WAAW;AACX;;AAEA;AACA,aAAa;AACb,QAAQ;AACR,mBAAmB;AACnB;;AAEA;AACA,WAAW;AACX;;AAEA;AACA,eAAe;AACf,cAAc;AACd,gBAAgB;AAChB,WAAW;AACX;;AAEA;AACA,aAAa;AACb,mBAAmB;AACnB,yBAAyB;AACzB,SAAS;AACT,mBAAmB;AACnB;;AAEA;AACA,eAAe;AACf,cAAc;AACd,gBAAgB;AAChB,WAAW;AACX;;AAEA;AACA,WAAW;AACX,eAAe;AACf;;AAEA;AACA,eAAe;AACf,cAAc;AACd,eAAe;AACf,WAAW;AACX,eAAe;AACf;;;;AAIA,kDAAkD;AAClD;AACA,WAAW;AACX,YAAY;AACZ;;AAEA;AACA,eAAe;AACf;;AAEA;AACA,YAAY;AACZ,YAAY;AACZ,mBAAmB;AACnB;;AAEA;AACA,eAAe;AACf,cAAc;AACd,gBAAgB;AAChB;;AAEA;AACA,WAAW;AACX,eAAe;AACf;;AAEA;AACA,eAAe;AACf,gBAAgB;AAChB;;AAEA;AACA,SAAS;AACT;;AAEA;AACA,mBAAmB;AACnB;;;AAGA;AACA,gBAAgB;AAChB,WAAW;AACX,gBAAgB;AAChB,mBAAmB;AACnB;;AAEA;AACA,gBAAgB;AAChB,YAAY;AACZ;;AAEA;AACA,2BAA2B;AAC3B,2BAA2B;AAC3B,mBAAmB;AACnB;;;AAGA,oCAAoC;;AAEpC;AACA,aAAa;AACb,mBAAmB;AACnB,8BAA8B;AAC9B,YAAY;AACZ,iBAAiB;AACjB,mBAAmB;AACnB,WAAW;AACX;;AAEA;AACA,WAAW;AACX;;AAEA;AACA,aAAa;AACb,mBAAmB;AACnB,QAAQ;AACR;;AAEA;AACA,WAAW;AACX;;AAEA;AACA,eAAe;AACf,cAAc;AACd,gBAAgB;AAChB,WAAW;AACX;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;AACA,YAAY;AACZ;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;;GAEG;;AAEH;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,aAAa;AACf;;AAEA;AACA,gCAAgC;AAChC;AACA;;AAEA;AACA,eAAe;AACf,cAAc;AACd,gBAAgB;AAChB,WAAW;AACX;;AAEA;AACA,cAAc;AACd;;AAEA;AACA,kBAAkB;AAClB,WAAW;AACX,SAAS;AACT;;AAEA;AACA,aAAa;AACb;;AAEA,2BAA2B;AAC3B;AACA;EACE,WAAW;EACX,mCAAmC;EACnC,kBAAkB;EAClB,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,mCAAmC;EACnC,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,SAAS;AACX;;;AAGA;AACA,kBAAkB;AAClB;;AAEA;AACA,2BAA2B;AAC3B,2BAA2B;AAC3B,kBAAkB;AAClB;;AAEA;AACA,gBAAgB;AAChB,YAAY;AACZ;;AAEA;AACA,WAAW;AACX,kBAAkB;AAClB,4BAA4B;AAC5B;;AAEA;AACA,WAAW;AACX;;AAEA;AACA,iBAAiB;AACjB;;AAEA;AACA,WAAW;AACX,YAAY;AACZ;;AAEA;AACA,YAAY;AACZ,eAAe;AACf;;AAEA;AACA,aAAa;AACb,mBAAmB;AACnB,8BAA8B;AAC9B,mBAAmB;AACnB,YAAY;AACZ,kBAAkB;AAClB,iBAAiB;AACjB,eAAe;AACf,aAAa;AACb,UAAU;AACV;;AAEA;AACA,eAAe;AACf;;AAEA;AACA,eAAe;AACf;;AAEA;AACA,WAAW;AACX;;AAEA;AACA,SAAS;AACT,mBAAmB;AACnB;;AAEA;AACA,gBAAgB;AAChB;;;AAGA;AACA,eAAe;AACf;;AAEA;AACA,UAAU;AACV;;AAEA;AACA,YAAY;AACZ;;AAEA;AACA,WAAW;AACX;;AAEA;AACA,eAAe;AACf;;AAEA;AACA,eAAe;AACf;;AAEA;AACA,kBAAkB;AAClB;;AAEA;AACA,aAAa;AACb,qCAAqC;AACrC;;AAEA;AACA,aAAa;AACb,qCAAqC;AACrC,QAAQ;AACR;;AAEA;AACA,mBAAmB;AACnB;;AAEA;AACA,WAAW;AACX;;AAEA;AACA,eAAe;AACf;;AAEA;AACA,gBAAgB;AAChB;;AAEA;AACA,kBAAkB;AAClB,WAAW;AACX,SAAS;AACT;;AAEA;AACA,UAAU;AACV;;AAEA;AACA,mBAAmB;AACnB;;AAEA;AACA,WAAW;AACX;;;AAGA;;;AAGA;AACA;EACE,YAAY;AACd;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;;AAEA;AACA;EACE,YAAY;EACZ,mCAAmC;EACnC,gCAAgC;EAChC,2BAA2B;EAC3B,cAAc;EACd,gBAAgB;AAClB;;AAEA;AACA,eAAe;AACf,mBAAmB;AACnB;;AAEA;AACA,eAAe;AACf;;AAEA;AACA,WAAW;AACX,YAAY;AACZ;;AAEA;AACA,YAAY;AACZ,YAAY;AACZ,kBAAkB;AAClB,eAAe;AACf;;AAEA;AACA,WAAW;AACX;;AAEA;AACA,eAAe;AACf;;AAEA;AACA,mBAAmB;AACnB,SAAS;AACT;;AAEA;AACA,eAAe;AACf;;AAEA;AACA,gBAAgB;AAChB,YAAY;AACZ;;AAEA;AACA,mBAAmB;AACnB;;AAEA;AACA,2BAA2B;AAC3B;;;AAGA;AACA,YAAY;AACZ,4BAA4B;AAC5B;;AAEA;AACA,gBAAgB;AAChB;;AAEA;AACA,YAAY;AACZ,YAAY;AACZ,gBAAgB;AAChB;;;AAGA;AACA,eAAe;AACf;;AAEA;AACA,WAAW;AACX;;AAEA;AACA,SAAS;AACT,mBAAmB;AACnB;;AAEA;AACA,YAAY;AACZ,YAAY;AACZ,kBAAkB;AAClB,iBAAiB;AACjB,aAAa;AACb;;AAEA;AACA,gBAAgB;AAChB;;AAEA;AACA,eAAe;AACf;;AAEA;AACA,eAAe;AACf;;;AAGA;AACA,WAAW;AACX;;AAEA;AACA,eAAe;AACf;;AAEA;AACA,kBAAkB;AAClB,YAAY;AACZ;;AAEA;AACA,eAAe;AACf;;AAEA;AACA,eAAe;AACf;;AAEA;AACA,WAAW;AACX;;AAEA;;;AAGA;AACA;EACE,YAAY;EACZ,mCAAmC;EACnC,gCAAgC;EAChC,2BAA2B;EAC3B,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;AACA,eAAe;AACf,mBAAmB;AACnB;;AAEA;AACA,eAAe;AACf;;AAEA;AACA,WAAW;AACX,YAAY;AACZ;;AAEA;AACA,YAAY;AACZ,YAAY;AACZ,kBAAkB;AAClB,eAAe;AACf;;AAEA;AACA,WAAW;AACX;;AAEA;AACA,eAAe;AACf;;AAEA;AACA,mBAAmB;AACnB,SAAS;AACT;;AAEA;AACA,eAAe;AACf;;AAEA;AACA,gBAAgB;AAChB,YAAY;AACZ;;AAEA;AACA,mBAAmB;AACnB;;AAEA;AACA,2BAA2B;AAC3B;;;AAGA;AACA,YAAY;AACZ,4BAA4B;AAC5B;;AAEA;AACA,gBAAgB;AAChB;;AAEA;AACA,YAAY;AACZ,YAAY;AACZ,gBAAgB;AAChB;;AAEA;AACA,eAAe;AACf;;AAEA;AACA,WAAW;AACX;;AAEA;AACA,SAAS;AACT,mBAAmB;AACnB;;AAEA;AACA,YAAY;AACZ,YAAY;AACZ,kBAAkB;AAClB,iBAAiB;AACjB,aAAa;AACb;;AAEA;AACA,gBAAgB;AAChB;;AAEA;AACA,eAAe;AACf;;AAEA;AACA,eAAe;AACf;;AAEA;AACA,eAAe;AACf;;AAEA;AACA,gBAAgB;AAChB;;AAEA;AACA,WAAW;AACX;;AAEA;AACA,eAAe;AACf;;AAEA;AACA,kBAAkB;AAClB,YAAY;AACZ;;AAEA;AACA,eAAe;AACf;;AAEA;AACA,eAAe;AACf;;AAEA;AACA,eAAe;AACf;;AAEA;AACA,WAAW;AACX;AACA;;;;;AAKA;;AAEA","sourcesContent":["div#ActivateAcc {\r\n  width: 725px;\r\n  box-shadow: -5px 0px 14px #0000000D;\r\n  border-radius: 34px 0px 0px 34px;\r\n  border-left: 5px solid #00A19B;\r\n  padding: 30px 0px 0px 40px;\r\n  z-index: 99999;\r\n  border: none;\r\n}\r\n\r\ndiv#customizeDatecanvasRight {\r\n  width: 725px;\r\n  box-shadow: -5px 0px 14px #0000000D;\r\n  border-radius: 34px 0px 0px 34px;\r\n  border-left: 5px solid #00A19B;\r\n  padding: 30px 0px 0px 40px;\r\n  z-index: 99999;\r\n  border: none;\r\n}\r\n\r\ndiv#customizeDatecanvasRight .offcanvas-body {\r\n  padding: 0px 60px;\r\n}\r\n\r\n.offcanvas-header {\r\n  display: flex;\r\n  align-items: center;\r\n  text-align: left;\r\n  justify-content: space-between;\r\n  padding: 1rem 1rem;\r\n  border-bottom: 1px solid #ccc;\r\n  margin: 0px 60px;\r\n}\r\n\r\n.notification-drawer-main-wrapper {\r\n  overflow: auto;\r\n  height: 94vh;\r\n}\r\n\r\n.profile-icon {\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.offcanvas-body {\r\n  overflow: auto;\r\n  /* height: 100vh; */\r\n  padding-bottom: 100px;\r\n}\r\n\r\n.profile-icon img {\r\n  width: 40px;\r\n  height: 40px;\r\n  cursor: pointer;\r\n  object-fit: cover;\r\n  object-position: center;\r\n}\r\n\r\n.profile-icon {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n  margin-bottom: 20px;\r\n  margin-left: 30px;\r\n}\r\n\r\n.profile-icon p {\r\n  color: #383838;\r\n  font-size: 16px;\r\n  margin: 0px;\r\n  cursor: pointer;\r\n}\r\n\r\n.profile-drawer-bottom {\r\n  /* margin-top: 75%; */\r\n  border-top: 1px solid #ccc;\r\n  padding: 15px;\r\n}\r\n\r\n.profile-drawer-bottom button {\r\n  background: var(--buttonColor);\r\n  border-radius: 5px;\r\n  opacity: 1;\r\n  border: none;\r\n  color: #383838;\r\n  padding: 10px;\r\n  width: 70%;\r\n  margin: 0 auto;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.profile-drawer-bottom button:hover {\r\n  background-color: var(--buttonHover);\r\n}\r\n\r\n.principle-open-drawer .table > tbody {\r\n  vertical-align: inherit;\r\n  border-top: 2px solid #ccc !important;\r\n  border-left: none;\r\n  border-right: none;\r\n}\r\n\r\n.principle-open-drawer .table > tbody td {\r\n  color: #717171;\r\n  text-align: center;\r\n  font-size: 15px;\r\n}\r\n\r\n.principle-open-drawer .table > tbody th {\r\n  color: #383838;\r\n  text-align: center;\r\n}\r\n\r\n.principle-open-drawer .table > :not(caption) > * > * {\r\n  padding: 12px;\r\n  font-size: 14px;\r\n}\r\n\r\n.principle-open-drawer .table-header {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-around;\r\n  gap: 31px;\r\n  background: #fff4d5;\r\n  padding: 6px 0px;\r\n  text-align: center;\r\n  border-bottom: 1.5px solid #5e5e5e;\r\n  margin-top: -16px;\r\n}\r\n\r\n.principle-open-drawer .table-header p {\r\n  margin: 0px;\r\n  color: #383838;\r\n  font-size: 13px;\r\n  font-weight: 500;\r\n}\r\n\r\n.tranfer-manage-holder img {\r\n  width: 15px;\r\n  cursor: pointer;\r\n}\r\n\r\n/* .close-principle-drawer-footer {\r\n  position: absolute;\r\n  bottom: 80px;\r\n} */\r\n\r\n.profit-total-wrap {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  gap: 150px;\r\n  border-bottom: 1.5px solid #383838;\r\n}\r\n\r\n.profit-total-wrap h3 {\r\n  font-size: 16px;\r\n  color: #383838;\r\n  margin: 0px;\r\n  padding-bottom: 8px;\r\n}\r\n\r\n.profit-total-wrap p {\r\n  font-size: 14px;\r\n  color: #383838;\r\n  margin: 0px;\r\n  padding-bottom: 8px;\r\n}\r\n\r\n.total-profit-wrapper {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  margin-top: 15px;\r\n}\r\n\r\n.total-profit h2 {\r\n  font-size: 18px;\r\n  color: #383838;\r\n}\r\n\r\n.total-profit-balance button {\r\n  border: 1.5px solid transparent;\r\n  background: var(--buttonBorder);\r\n  background-origin: border-box;\r\n  border-radius: 6px;\r\n  box-shadow: inset 2px 1000px 1px #fff;\r\n}\r\n\r\n/********** Create Principle *****/\r\n.currency-box {\r\n  width: 90px;\r\n  height: 40px;\r\n  border: 1px solid var(--buttonColor);\r\n  border-radius: 8px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 10px;\r\n}\r\n\r\n.currency-box img {\r\n  width: 30px;\r\n  height: 30px;\r\n}\r\n\r\n.currency-box p {\r\n  font-size: 16px;\r\n  margin: 0px;\r\n  color: #383838 !important;\r\n}\r\n\r\n.principle-currency-wrap {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-around;\r\n}\r\n\r\n.principle-currency-wrap p {\r\n  font-size: 14px;\r\n  color: #858585;\r\n  margin: 0px;\r\n}\r\n\r\n.subscription-amount-wrap {\r\n  width: 80%;\r\n  margin: 0 auto;\r\n  margin-top: 20px;\r\n}\r\n\r\n.subscription-amount-wrap input {\r\n  width: 100%;\r\n  padding: 5px 15px;\r\n  border: 1px solid #707070;\r\n  border-radius: 6px;\r\n  font-size: 17px;\r\n  color: #858585;\r\n  font-weight: 200;\r\n  outline: none;\r\n}\r\n\r\n.subscription-amount-wrap p {\r\n  padding-top: 9px;\r\n  font-size: 12px;\r\n  color: #858585;\r\n}\r\n\r\n.principle-summary-wrapper {\r\n  width: 80%;\r\n  margin: 0 auto;\r\n}\r\n\r\n/* .summary-wrap {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n} */\r\n\r\n.time-box {\r\n  width: 24px;\r\n  height: 25px;\r\n  border-radius: 5px;\r\n  background: var(--buttonColor);\r\n}\r\n\r\n.date-box {\r\n  width: 24px;\r\n  height: 25px;\r\n  border-radius: 5px;\r\n  background: #275354;\r\n}\r\n\r\n.create-time {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  padding-top: 10px;\r\n}\r\n\r\n.summary-right p {\r\n  font-size: 14px;\r\n}\r\n\r\n.vartcal-line {\r\n  height: 31px;\r\n  width: 2px;\r\n  background: #707070;\r\n  text-align: center;\r\n  margin-left: 10px;\r\n}\r\n\r\n.time-box-wrap {\r\n  display: flex;\r\n  gap: 10px;\r\n}\r\n\r\n.time-box-wrap p {\r\n  font-size: 15px;\r\n  color: #383838;\r\n}\r\n\r\n.summary-time p {\r\n  font-size: 12px;\r\n  color: #858585;\r\n}\r\n\r\n.principle-security {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 10px;\r\n  width: 100%;\r\n  text-align: center;\r\n}\r\n\r\n.principle-security img {\r\n  width: 30px;\r\n  height: 30px;\r\n}\r\n\r\n.principle-security p {\r\n  font-size: 10px;\r\n  margin: 0px;\r\n  color: #9c9c9c;\r\n}\r\n\r\n.procced-button button {\r\n  background: var(--buttonColor);\r\n  border-radius: 5px;\r\n  opacity: 1;\r\n  border: none;\r\n  color: #383838;\r\n  padding: 8px 50px;\r\n  margin-top: 20px;\r\n}\r\n\r\n.procced-button button:hover {\r\n  background-color: var(--buttonHover);\r\n}\r\n\r\n.procced-button {\r\n  text-align: center;\r\n  border-bottom: 1px solid #707070;\r\n  padding-bottom: 24px;\r\n}\r\n\r\n.confirm-button-wrap button {\r\n  background: #00A19B;\r\n  border-radius: 10px;\r\n  opacity: 1;\r\n  border: none;\r\n  color: #fff;\r\n  padding: 8px 40px;\r\n  margin-top: 20px;\r\n}\r\n\r\n\r\nsvg.drawer-cross-icon{\r\n  cursor: pointer;\r\n  width: 38px;\r\n  height: 38px;\r\n}\r\n\r\nsvg.drawer-cross-icon:hover path{\r\n  fill: #00A19B; \r\n}\r\n\r\n.confirm-button-wrap {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 10px;\r\n}\r\n\r\nbutton.cancel-button {\r\n  background: #F3F3F3;\r\n  border: 1px solid #00A19BF7 !important;\r\n  border-radius: 10px;\r\n  opacity: 1;\r\n  border: none;\r\n  color: #00A19BF7;\r\n  padding: 8px 40px;\r\n  margin-top: 20px;\r\n}\r\n\r\n/********* Wallet Drawer *******/\r\n\r\n.wallet-drawer-wrapper {\r\n  width: 80%;\r\n  margin: 0 auto;\r\n}\r\n\r\n.overview-right img {\r\n  width: 20px;\r\n  height: 20px;\r\n}\r\n\r\n.wallet-overview {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  border-bottom: 1px dashed #ccc;\r\n  padding-bottom: 8px;\r\n}\r\n\r\n.overview-right h3 {\r\n  font-size: 15px;\r\n  color: #858585;\r\n}\r\n\r\n.overview-right p {\r\n  font-size: 24px;\r\n  margin: 0px;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 5px;\r\n}\r\n.overview-right span {\r\n  color: #858585;\r\n  font-size: 15px;\r\n}\r\n\r\n.overview-left h4 {\r\n  color: #858585;\r\n  font-size: 17px;\r\n  margin: 0px;\r\n}\r\n\r\n.wealth-transfer-wrap {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding-top: 25px;\r\n}\r\n\r\n.wealth-transfer-right button {\r\n  background: var(--buttonColor);\r\n  border-radius: 5px;\r\n  opacity: 1;\r\n  border: none;\r\n  color: #383838;\r\n  padding: 5px 10px;\r\n}\r\n\r\n.wealth-transfer-right h3 {\r\n  color: #383838;\r\n  font-size: 16px;\r\n  cursor: pointer;\r\n}\r\n\r\n.wealth-transfer-left h3 {\r\n  color: #383838;\r\n  font-size: 16px;\r\n}\r\n\r\n.wealth-transfer-left span {\r\n  font-size: 12px;\r\n  color: #858585;\r\n}\r\n\r\n.wealth-transfer-left p {\r\n  font-size: 15px;\r\n  color: #858585;\r\n  margin: 0px;\r\n}\r\n\r\n.wealth-transfer-wrapper {\r\n  border-bottom: 1px dashed #ccc;\r\n  padding-bottom: 20px;\r\n}\r\n\r\n.wealth-transfer-wrapper-2 {\r\n  border-bottom: 1px solid #ccc;\r\n  padding-bottom: 20px;\r\n}\r\n\r\n.tranfer-manage-holder {\r\n  width: 100%;\r\n  height: 245px;\r\n  box-shadow: 0px 3px 6px #00000029;\r\n  border: 1px solid #fbc425;\r\n  border-radius: 9px;\r\n  margin-top: 3px;\r\n  text-align: center;\r\n  background: #fff;\r\n}\r\n\r\n.transfer-select-wraper {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  margin: 10px 6px;\r\n  align-items: center;\r\n  margin-top: 5px;\r\n  gap: 10px;\r\n}\r\n\r\n.transfer-select-wraper-2 {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  margin: 10px 6px;\r\n  gap: 10px;\r\n  text-align: left;\r\n}\r\n\r\n.transfer-filter {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 10px;\r\n}\r\n\r\n.transfer-filter select {\r\n  padding: 8px 10px;\r\n  border: 1px solid var(--buttonColor);\r\n  border-radius: 5px;\r\n  outline: none;\r\n  color: #383838;\r\n  font-size: 14px;\r\n  font-weight: 300;\r\n  width: 114px;\r\n}\r\n\r\n.transfer-icon {\r\n  background: var(--buttonColor);\r\n  padding: 3px 8px;\r\n  border-radius: 6px;\r\n  box-shadow: 0px 3px 6px #00000029;\r\n}\r\n\r\n.transfer-filter input {\r\n  padding: 8px 10px;\r\n  border: 1px solid var(--buttonColor);\r\n  border-radius: 5px;\r\n  outline: none;\r\n  color: #383838;\r\n  font-size: 14px;\r\n  font-weight: 300;\r\n  width: 114px;\r\n}\r\n.transfer-filter.quantity {\r\n  position: relative;\r\n}\r\n\r\n.count-button {\r\n  position: absolute;\r\n  right: 8px;\r\n  top: 29px;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  background-color: #fff;\r\n}\r\n\r\n.count-button .plus-btn {\r\n  width: 20px;\r\n  height: 14px;\r\n  background: #383838;\r\n  color: #fff;\r\n  margin-bottom: 4px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  cursor: pointer;\r\n}\r\n\r\n.count-button p {\r\n  font-size: 12px;\r\n  color: #717171;\r\n  margin: 0px;\r\n}\r\n\r\n.transfer-filter h3 {\r\n  font-size: 14px;\r\n  margin: 0px;\r\n  color: #383838;\r\n}\r\n\r\n.confirm-buttons button {\r\n  background: var(--buttonColor);\r\n  border-radius: 5px;\r\n  opacity: 1;\r\n  border: none;\r\n  color: #383838;\r\n  padding: 5px 10px;\r\n  margin-top: 20px;\r\n}\r\n\r\n.tranfer-manage-holder img {\r\n  width: 15px;\r\n  cursor: pointer;\r\n}\r\n\r\n.continue-wrap {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-around;\r\n}\r\n\r\n.box-1 {\r\n  width: 15px;\r\n  height: 15px;\r\n  border-radius: 3px;\r\n  background: var(--buttonColor);\r\n}\r\n\r\n.box-2 {\r\n  width: 15px;\r\n  height: 15px;\r\n  border-radius: 3px;\r\n  background: #275354;\r\n}\r\n\r\n.continue-wrap p {\r\n  font-size: 13px;\r\n  margin: 0px;\r\n}\r\n\r\n.arrow svg {\r\n  font-size: 21px;\r\n}\r\n\r\n.box-wrap {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 7px;\r\n}\r\n\r\n.transfer-line {\r\n  width: 50px;\r\n  height: 1.5px;\r\n  background: #383838;\r\n}\r\n\r\n.wealth-transfer-right button:hover {\r\n  background-color: var(--buttonHover);\r\n}\r\n\r\n.confirm-buttons button:hover {\r\n  background-color: var(--buttonHover);\r\n}\r\n\r\n\r\n/************ Customize Time Range ********/\r\n.time-range-wrapper {\r\n  display: flex;\r\n  /* align-items: center; */\r\n  justify-content: center;\r\n  flex-direction: column;\r\n  /* margin-top: 70px; */\r\n  height: calc(100vh - 450px);\r\n}\r\n\r\n.time-range-wrapper input {\r\n  width: 100%;\r\n  padding: 8px 20px;\r\n  border-radius: 10px;\r\n  font-size: 14px;\r\n  background-color: #F8F8F8;\r\n  height: 85px;\r\n  border: none;\r\n  outline: none;\r\n}\r\n\r\n.time-range-wrapper label {\r\n  font-size: 22px;\r\n  text-align: left;\r\n  padding-bottom: 8px;\r\n  color: #383838;\r\n  margin-left: 20px;\r\n  font-family: 'Montserrat';\r\n  font-weight: 400;\r\n}\r\n\r\n.customize-time-wrap p {\r\n  font-size: 24px;\r\n  color: #717171;\r\n  font-family: 'Montserrat';\r\n  font-weight: 400;\r\n  margin-top: 30px;\r\n}\r\n\r\n.time-range-wrapper h4 {\r\n  font-size: 20px;\r\n  padding: 30px 0px;\r\n  text-align: center;\r\n  margin: 0px;\r\n  color: #00A19B;\r\n}\r\n\r\n.customize-security {\r\n  display: flex;\r\n  /* align-items: center; */\r\n  justify-content: center;\r\n  width: 100%;\r\n  margin: 0 auto;\r\n  gap: 15px;\r\n  border-bottom: 1px solid #F8F8F8;\r\n  padding-bottom: 10px;\r\n}\r\n\r\n.customize-security img {\r\n  width: 30px;\r\n  height: 30px;\r\n  margin-top: 7px;\r\n}\r\n\r\n.customize-range-footer {\r\n  margin-top: 80px;\r\n}\r\n\r\n.customize-security p {\r\n  font-size: 16px;\r\n  margin: 0px;\r\n  color: #9c9c9c;\r\n}\r\n\r\n.customize-btn {\r\n  text-align: center;\r\n  margin-top: 20px;\r\n}\r\n\r\n.customize-btn button {\r\n  background: #00A19B;\r\n  border-radius: 5px;\r\n  opacity: 1;\r\n  border: none;\r\n  padding: 8px 40px;\r\n  width: 100%;\r\n  height: 70px;\r\n  color: #fff;\r\n}\r\n\r\n.customize-btn button:hover {\r\n  background-color: #fff;\r\n  border: 2px solid #00A19B;\r\n  color: #383838;\r\n}\r\n\r\n.start-time {\r\n  width: 100%;\r\n}\r\n\r\n\r\n.wealth-transfer-right .wealth-hover {\r\n  font-size: 0px;\r\n}\r\n\r\nspan.wealth-hover img {\r\n  height: 0px;\r\n}\r\n\r\n.wealth-transfer-right h3:hover span.wealth-hover img {\r\n  height: 16px;\r\n}\r\n\r\n.wealth-transfer-right h3:hover .wealth-hover {\r\n  font-size: 16px;\r\n  color: #ffd458;\r\n  transition: all 500ms ease-in-out;\r\n}\r\n\r\n.wealth-transfer-right h3:hover .wealth {\r\n  font-size: 0px;\r\n  transition: 0.2s;\r\n}\r\n\r\n.profile-content-wrap {\r\n  min-height: calc(100vh - 180px);\r\n}\r\n\r\n/********** Mobile filter *******/\r\n.mobile-drawer-filter select {\r\n  padding: 12px 15px;\r\n  margin-bottom: 20px;\r\n  border: 1px solid var(--buttonColor);\r\n  border-radius: 5px;\r\n  outline: none;\r\n  font-weight: 400;\r\n  gap: 20px;\r\n  cursor: pointer;\r\n  background: #fff !important;\r\n  font-size: 20px;\r\n  color: #383838;\r\n}\r\n\r\n.mobile-filter-drawer-wrap {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  flex-direction: column;\r\n  gap: 40px;\r\n  margin: 0px 20px;\r\n}\r\n\r\n.mobile-filter-drawer-wrap h3 {\r\n  font-size: 24px;\r\n  color: #383838;\r\n  padding-top: 30px;\r\n}\r\n\r\n/************* Activate Account Drawer *******/\r\n.activate-acc-wrap {\r\n  /* text-align: center; */\r\n  margin: 0px 45px;\r\n}\r\n\r\n\r\n.security-logo {\r\n  text-align: center;\r\n}\r\n\r\n\r\n.activate-acc-wrap p {\r\n  font-size: 24px;\r\n  color: #383838;\r\n  margin-top: 50px;\r\n}\r\n\r\n.security-logo img {\r\n  width: 200px;\r\n  height: 200px;\r\n  object-fit: contain;\r\n  margin-top: 150px;\r\n}\r\n\r\n\r\n.twofa-disable-drawer-wrapper {\r\n  margin: 0px 60px;\r\n}\r\n\r\n\r\n.twofa-status-drawer-wrapper {\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  align-items: center;\r\n  margin-top: 10px;\r\n  height: calc(100vh - 350px);\r\n}\r\n\r\n.twofa-status-drawer-wrapper img{\r\n  width: 140px;\r\n  height: auto;\r\n}\r\n\r\n.twofa-status-drawer-wrapper p {\r\n  font-size: 22px;\r\n  color: #383838;\r\n  /* margin: 0px; */\r\n  margin-top: 15px !important;\r\n  margin-bottom: 0px;\r\n}\r\n\r\n\r\n.twofa-status-drawer-wrapper h2 {\r\n  font-size: 32px;\r\n  color: #1AA400;\r\n  font-weight: 500;\r\n}\r\n\r\n@media (max-width: 768px) {\r\n\r\n  .offcanvas-header {\r\n    margin: 0px 30px;\r\n  }\r\n\r\n  .profile-content-wrap {\r\n    min-height: calc(100vh - 240px);\r\n  }\r\n\r\n  .principle-currency-wrap {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    justify-content: space-around;\r\n  }\r\n\r\n  .currency-box {\r\n    width: 129px;\r\n    height: 63px;\r\n  }\r\n\r\n  .currency-box img {\r\n    width: 38px;\r\n    height: 38px;\r\n  }\r\n  .principle-currency-wrap p {\r\n    font-size: 18px;\r\n  }\r\n  .subscription-amount-wrap input {\r\n    width: 100%;\r\n    height: 65px;\r\n    font-size: 20px;\r\n  }\r\n\r\n  .subscription-amount-wrap p {\r\n    padding-top: 9px;\r\n    font-size: 14px;\r\n    color: #858585;\r\n    text-align: center;\r\n    margin-top: 12px;\r\n  }\r\n  .time-box-wrap p {\r\n    font-size: 16px;\r\n    color: #383838;\r\n  }\r\n  .procced-button button {\r\n    font-size: 20px;\r\n  }\r\n  .principle-security p {\r\n    font-size: 11px;\r\n  }\r\n  .principle-summary-wrapper h4 {\r\n    font-size: 24px;\r\n  }\r\n  .create-time.total-principle {\r\n    margin: 20px 0px;\r\n  }\r\n\r\n  .activate-acc-wrap p {\r\n    font-size: 14px;\r\n    color: #717171;\r\n    text-align: left;\r\n    margin-top: 40px;\r\n  }\r\n\r\n  .security-logo img {\r\n    width: 160px;\r\n    height: 160px;\r\n    object-fit: contain;\r\n    margin-top: 100px;\r\n    margin-bottom: 80px;\r\n  }\r\n\r\n  div#ActivateAcc {\r\n    width: 100%;\r\n    border-radius: 0px;\r\n    padding: 20px 0px 0px 10px;\r\n    z-index: 99999;\r\n    border: none;\r\n}\r\n\r\n.activate-drawer-bottom {\r\n  margin: 0px 20px;\r\n  position: absolute;\r\n  bottom: 20px;\r\n  right: 0;\r\n  left: 0;\r\n}\r\n\r\n  p.sure-text {\r\n    font-size: 18px;\r\n  }\r\n\r\n  svg.drawer-cross-icon{\r\n    cursor: pointer;\r\n    width: 32px;\r\n    height: 32px;\r\n  }\r\n\r\n  .admin-sidebar-space {\r\n    margin-left: 0px;\r\n  }\r\n\r\n  .activate-acc-wrap {\r\n    margin: 0px 20px;\r\n}\r\n\r\n  .confirm-button-wrap button{\r\n    height: 50px;\r\n  }\r\n\r\n  .customize-time-drawer-wrapper {\r\n    margin: 0px 10px;\r\n    padding-bottom: 70px;\r\n  }\r\n  \r\n  .customize-time-wrap p {\r\n    font-size: 16px;\r\n  }\r\n  \r\n  .time-range-wrapper label {\r\n    font-size: 18px;\r\n  }\r\n  \r\n  .time-range-wrapper input{\r\n    height: 60px;\r\n  }\r\n  \r\n  .customize-security p {\r\n    font-size: 14px;\r\n  }\r\n  \r\n  .customize-btn button {\r\n    width: 100%;\r\n    height: 55px;\r\n  }\r\n  \r\n  svg.drawer-cross-icon {\r\n    cursor: pointer;\r\n    width: 26px;\r\n    height: 26px;\r\n  }\r\n}\r\n\r\n@media (min-width: 768px) {\r\n  .activate-acc-wrap p {\r\n    font-size: 16px;\r\n    text-align: left;\r\n    color: #717171;\r\n    margin-top: 16px;\r\n  }\r\n  .security-logo img {\r\n    width: 150px;\r\n    height: 150px;\r\n    object-fit: contain;\r\n    margin-top: 60px;\r\n  }\r\n\r\n  p.sure-text {\r\n    font-size: 22px;\r\n  }\r\n\r\n  .principle-security {\r\n    padding-bottom: 15px;\r\n    border-bottom: 1px solid #ccc;\r\n  }\r\n\r\n  .activate-drawer-bottom {\r\n    margin: 0px 50px;\r\n    position: absolute;\r\n    bottom: 10px;\r\n    right: 0;\r\n    left: 0;\r\n}\r\n\r\n\r\n\r\n.confirm-button-wrap button{\r\n  height: 49px;\r\n  font-size: 14px;\r\n}\r\n\r\n.twofa-status-drawer-wrapper{\r\n  height: unset;\r\n}\r\n\r\n.twofa-status-drawer-wrapper img {\r\n  width: 110px;\r\n  height: auto;\r\n}\r\n\r\n.principle-security{\r\n  margin-top: 40px;\r\n}\r\n\r\n.principle-security p {\r\n  font-size: 16px;\r\n  text-align: left;\r\n}\r\n\r\n.disable-twofa-input-wrap p {\r\n  font-size: 18px;\r\n  color: #717171;\r\n}\r\n\r\n\r\n}\r\n\r\n\r\n@media (min-width: 768px) and (max-width:1599px) {\r\n\r\n  div#customizeDatecanvasRight {\r\n    width: 500px;\r\n    border-radius: 24px 0px 0px 24px;\r\n    padding: 20px 0px 0px 20px;\r\n  }\r\n\r\n  div#customizeDatecanvasRight .offcanvas-body {\r\n    padding: 0px 10px;\r\n  }\r\n\r\n  .offcanvas-header {\r\n    margin: 0px 30px;\r\n  }\r\n\r\n  .time-range-wrapper{\r\n    height: unset;\r\n    margin-top: 35px;\r\n   }\r\n   \r\n   .customize-time-wrap p {\r\n    font-size: 14px;\r\n   }\r\n\r\n   .customize-security img {\r\n    width: 20px;\r\n    height: 20px;\r\n   }\r\n   \r\n   .time-range-wrapper input {\r\n     width: 100%;\r\n     height: 60px;\r\n     font-size: 16px;\r\n     color: #717171;\r\n   }\r\n   \r\n   .time-range-wrapper h4 {\r\n     font-size: 18px;\r\n     padding: 15px 0px;\r\n     padding-bottom: 5px;\r\n   }\r\n   \r\n   .time-range-wrapper label {\r\n     font-size: 18px;\r\n     padding-bottom: 5px;\r\n   }\r\n   \r\n   .customize-btn button {\r\n     width: 100%;\r\n     height: 58px;\r\n   }\r\n   \r\n   .customize-time-drawer-wrapper {\r\n     margin: 0px 30px;\r\n   }\r\n\r\n   div#ActivateAcc {\r\n    width: 560px;\r\n   }\r\n\r\n   p.sure-text {\r\n    font-size: 20px;\r\n  }\r\n\r\n  .security-logo img {\r\n    width: 120px;\r\n    height: 120px;\r\n    margin-top: 100px;\r\n  }\r\n   \r\n}\r\n\r\n@media (min-width: 1600px) {\r\n  .twofa-status-drawer-wrapper{\r\n    height: calc(100vh - 350px);\r\n  }\r\n\r\n  .time-range-wrapper {\r\n    height: calc(100vh - 480px);\r\n  }\r\n\r\n  .profile-icon img {\r\n    width: 50px;\r\n    height: 50px;\r\n  }\r\n\r\n  .wallet-drawer-wrapper {\r\n    padding-bottom: 80px;\r\n  }\r\n\r\n  .profile-icon p {\r\n    color: #383838;\r\n    font-size: 24px;\r\n  }\r\n\r\n  .profile-content-wrap {\r\n    min-height: calc(100vh - 240px);\r\n    margin-top: 40px;\r\n  }\r\n\r\n  .profile-drawer-bottom button {\r\n    font-size: 20px;\r\n  }\r\n\r\n  .profile-icon {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 20px;\r\n    margin-bottom: 38px;\r\n  }\r\n\r\n  .principle-open-drawer .table-header p {\r\n    font-size: 16px;\r\n  }\r\n\r\n  .principle-open-drawer .table > :not(caption) > * > * {\r\n    padding: 12px;\r\n    font-size: 16px;\r\n  }\r\n\r\n  .principle-open-drawer .table > tbody td {\r\n    color: #717171;\r\n    text-align: center;\r\n    font-size: 18px;\r\n  }\r\n\r\n  .profit-total-wrap h3 {\r\n    font-size: 19px;\r\n  }\r\n  .profit-total-wrap p {\r\n    font-size: 19px;\r\n    font-weight: 300;\r\n  }\r\n\r\n  .total-profit h2 {\r\n    font-size: 22px;\r\n    color: #383838;\r\n  }\r\n\r\n  .total-profit-balance button {\r\n    border: 2px solid transparent;\r\n    background: var(--buttonBorder);\r\n    background-origin: border-box;\r\n    border-radius: 6px;\r\n    box-shadow: inset 2px 1000px 1px #fff;\r\n    font-size: 19px;\r\n  }\r\n  .time-range-wrapper input {\r\n    width: 100%;\r\n    padding: 11px 15px;\r\n    font-size: 20px;\r\n  }\r\n\r\n  .time-range-wrapper label {\r\n    font-size: 20px;\r\n    text-align: left;\r\n  }\r\n\r\n  .time-range-wrapper h4 {\r\n    font-size: 24px;\r\n  }\r\n\r\n  .customize-time-wrap p {\r\n    font-size: 22px;\r\n  }\r\n\r\n  .customize-security p {\r\n    font-size: 16px;\r\n    margin: 0px;\r\n    color: #9c9c9c;\r\n  }\r\n\r\n  .customize-btn button {\r\n    font-size: 20px;\r\n  }\r\n\r\n  .overview-right h3 {\r\n    font-size: 22px;\r\n  }\r\n\r\n  .overview-right p {\r\n    font-size: 26px;\r\n  }\r\n\r\n  .overview-left h4 {\r\n    font-size: 22px;\r\n  }\r\n\r\n  .wealth-transfer-right h3 {\r\n    font-size: 22px;\r\n  }\r\n\r\n  .wealth-transfer-left h3 {\r\n    font-size: 20px;\r\n  }\r\n\r\n  .wealth-transfer-right button {\r\n    font-size: 20px;\r\n    padding: 5px 20px;\r\n  }\r\n\r\n  .tranfer-manage-holder {\r\n    width: 100%;\r\n    height: 370px;\r\n    padding: 20px;\r\n    margin-top: 10px;\r\n    position: relative;\r\n  }\r\n\r\n  .transfer-filter select {\r\n    font-size: 18px;\r\n  }\r\n  .transfer-filter select {\r\n    padding: 12px 10px;\r\n    width: 175px;\r\n  }\r\n\r\n  .transfer-filter input {\r\n    padding: 12px 10px;\r\n    width: 175px;\r\n  }\r\n\r\n  .transfer-filter h3 {\r\n    font-size: 20px;\r\n    padding: 5px 0px;\r\n    font-weight: 400;\r\n  }\r\n\r\n  .confirm-buttons button {\r\n    position: absolute;\r\n    left: 0;\r\n    right: 0;\r\n    margin: 0 auto;\r\n    bottom: 30px;\r\n    font-size: 20px;\r\n    width: 130px;\r\n  }\r\n\r\n  .box-1,\r\n  .box-2 {\r\n    width: 20px;\r\n    height: 20px;\r\n  }\r\n  .continue-wrap p {\r\n    font-size: 17px;\r\n    padding: 15px 0px;\r\n  }\r\n\r\n  .count-button p {\r\n    font-size: 18px;\r\n    margin-top: -2px;\r\n  }\r\n\r\n  .count-button {\r\n    top: 51px;\r\n  }\r\n\r\n  .transfer-filter input {\r\n    padding: 10px 10px;\r\n    width: 175px;\r\n    font-size: 16px;\r\n  }\r\n  .wealth-transfer-left span {\r\n    font-size: 16px;\r\n  }\r\n  .wealth-transfer-left p {\r\n    font-size: 18px;\r\n  }\r\n\r\n  .tranfer-manage-holder img {\r\n    width: 20px;\r\n  }\r\n\r\n  .arrow svg {\r\n    font-size: 27px;\r\n  }\r\n  .wealth-transfer-right h3:hover .wealth-hover {\r\n    font-size: 22px;\r\n    color: #ffd458;\r\n  }\r\n\r\n  .currency-box {\r\n    width: 140px;\r\n    height: 60px;\r\n  }\r\n\r\n  .principle-currency-wrap p {\r\n    font-size: 20px;\r\n  }\r\n\r\n  .currency-box img {\r\n    width: 38px;\r\n    height: 38px;\r\n  }\r\n\r\n  .subscription-amount-wrap input {\r\n    width: 100%;\r\n    margin-top: 20px;\r\n    height: 55px;\r\n    font-size: 20px;\r\n    border: 1.5px solid #ccc;\r\n  }\r\n\r\n  .subscription-amount-wrap p {\r\n    padding: 20px 0px;\r\n    font-size: 16px;\r\n    font-weight: 300;\r\n  }\r\n  .principle-summary-wrapper h4 {\r\n    font-size: 22px;\r\n  }\r\n\r\n  .time-box-wrap p {\r\n    font-size: 18px;\r\n    color: #383838;\r\n  }\r\n\r\n  .time-box,\r\n  .date-box {\r\n    width: 30px;\r\n    height: 30px;\r\n    border-radius: 3px;\r\n  }\r\n\r\n  .vartcal-line {\r\n    height: 50px;\r\n    width: 2px;\r\n    background: #707070;\r\n    text-align: center;\r\n    margin-left: 14px;\r\n  }\r\n\r\n  .summary-time p {\r\n    font-size: 16px;\r\n    color: #858585;\r\n  }\r\n  .total-principle {\r\n    margin-top: 40px;\r\n    margin-bottom: 70px;\r\n  }\r\n\r\n  .principle-security {\r\n    /* margin-top: 150px; */\r\n    border-bottom: 2px solid #ccc;\r\n    padding-bottom: 30px;\r\n  }\r\n\r\n  .principle-security p {\r\n    font-size: 16px;\r\n    color: #9c9c9c;\r\n  }\r\n  .procced-button button {\r\n    margin-top: 30px;\r\n    font-size: 20px;\r\n  }\r\n\r\n  .confirm-button-wrap button {\r\n    font-size: 18px !important;\r\n  }\r\n  .overview-right span {\r\n    font-size: 18px;\r\n  }\r\n  .principle-summary-wrapper {\r\n    margin-top: 30px;\r\n  }\r\n\r\n  .principle-open-drawer .table-header {\r\n    margin-top: -10px;\r\n  }\r\n  .profit-total-wrap {\r\n    display: flex;\r\n    justify-content: space-between;\r\n  }\r\n  .total-profit-wrapper {\r\n    display: flex;\r\n    justify-content: space-around;\r\n    gap: 200px;\r\n    margin-top: 15px;\r\n    padding-bottom: 50px;\r\n  }\r\n  .profit-total-wrap {\r\n    border-bottom: 2px solid #383838;\r\n    width: 90%;\r\n    margin: 0 auto;\r\n    padding: 10px 0px;\r\n  }\r\n  .close-principle-drawer-footer {\r\n    border-top: 1.5px solid #ccc;\r\n  }\r\n  .table-wrapper {\r\n    height: calc(100vh - 360px) !important;\r\n  }\r\n\r\n  .activate-acc-wrap p {\r\n    font-size: 24px;\r\n    color: #717171;\r\n    margin-top: 50px;\r\n  }\r\n\r\n  .principle-security p {\r\n    font-size: 20px;\r\n    color: #9c9c9c;\r\n    text-align: left;\r\n}\r\n\r\n.activate-acc-wrap .security-logo {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  height: 50vh;\r\n}\r\n\r\n\r\n.twofa-status-drawer-wrapper p {\r\n  font-size: 38px;\r\n}\r\n\r\n\r\n.twofa-status-drawer-wrapper h2 {\r\n  font-size: 50px;\r\n}\r\n\r\n.disable-twofa-input-wrap p {\r\n  font-size: 24px;\r\n  color: #717171;\r\n}\r\n\r\n.confirm-button-wrap button {\r\n  height: 62px;\r\n  font-size: 14px;\r\n}\r\n  \r\n}\r\n\r\n.customize-time-wrap {\r\n  height: 100vh;\r\n}\r\n\r\n.table-wrapper thead {\r\n  text-align: center;\r\n}\r\n\r\n.principle-open-drawer thead {\r\n  text-align: center;\r\n}\r\n\r\n@media (min-width: 1920px) {\r\n  .principle-open-drawer .table-header p {\r\n    font-size: 18px;\r\n  }\r\n\r\n  .principle-open-drawer .table > :not(caption) > * > * {\r\n    padding: 12px;\r\n    font-size: 20px;\r\n  }\r\n  .principle-open-drawer .table > tbody td {\r\n    font-size: 20px;\r\n  }\r\n\r\n  .profit-total-wrap h3 {\r\n    font-size: 22px;\r\n  }\r\n  .profit-total-wrap p {\r\n    font-size: 20px;\r\n    font-weight: 400;\r\n  }\r\n  .total-profit h2 {\r\n    font-size: 26px;\r\n    color: #383838;\r\n  }\r\n  .total-profit-balance button {\r\n    font-size: 20px;\r\n  }\r\n  .total-profit-balance {\r\n    font-size: 20px;\r\n  }\r\n\r\n}\r\n\r\n.principle-open-drawer .table > tbody td {\r\n  font-size: 20px;\r\n  border-left: none !important;\r\n}\r\n\r\n.principle-email {\r\n  text-align: center;\r\n  font-size: 18px;\r\n  margin-top: -22px;\r\n  margin-bottom: 25px;\r\n}\r\n\r\n\r\np.date-error-message {\r\n  font-size: 14px;\r\n  color: red;\r\n  margin: 6px;\r\n}\r\n\r\n\r\n\r\n/******************* New Drawer Css Start Here ***********/\r\n.history-offcanvas-wrapper.offcanvas.offcanvas-end.show {\r\n  width: 50%;\r\n  box-shadow: -5px 0px 14px #0000000D;\r\n  border-radius: 34px 0px 0px 34px;\r\n  padding: 40px 0px 40px 40px;\r\n  z-index: 99999;\r\n}\r\n\r\n.menu-offcanvas-wrapper.offcanvas.offcanvas-start.show {\r\nwidth: 337px;\r\nborder: none;\r\nz-index: 99999;\r\n}\r\n\r\n\r\n.notification-offcanvas-wrapper.offcanvas.offcanvas-end.show {\r\nwidth: 775px;\r\nbox-shadow: -5px 0px 14px #0000000D;\r\nborder-radius: 34px 0px 0px 34px;\r\npadding: 30px 20px 40px 40px;\r\nz-index: 99999;\r\n}\r\n\r\n\r\n.chat-offcanvas-wrapper.offcanvas.offcanvas-end.show {\r\nwidth: 725px;\r\nbox-shadow: -5px 0px 14px #0000000D;\r\nborder-radius: 34px 0px 0px 34px;\r\npadding: 20px 20px 10px 40px;\r\nz-index: 99999;\r\n}\r\n\r\n.service-offcanvas-wrapper.offcanvas.offcanvas-end.show {\r\nwidth: 725px;\r\nbox-shadow: -5px 0px 14px #0000000D;\r\nborder-radius: 34px 0px 0px 34px;\r\npadding: 20px 40px 10px 70px;\r\nz-index: 99999;\r\n}\r\n\r\n.bankdetail-offcanvas-wrapper.offcanvas.offcanvas-end.show {\r\nwidth: 622px;\r\nbox-shadow: -5px 0px 14px #0000000D;\r\nborder-radius: 34px 0px 0px 34px;\r\npadding: 58px 32px 20px 32px;\r\nz-index: 99999;\r\n}\r\n\r\n.availability-offcanvas-wrapper.offcanvas.offcanvas-end.show {\r\nwidth: 725px;\r\nbox-shadow: -5px 0px 14px #0000000D;\r\nborder-radius: 34px 0px 0px 34px;\r\npadding: 58px 0px 10px 70px;\r\nz-index: 99999;\r\nbackground: #fff;\r\n}\r\n\r\n.availability-offcanvas-wrapper .offcanvas-body {\r\npadding-bottom: 0px;\r\nmargin-bottom: 20px;\r\n}\r\n\r\n.availability-offcanvas-wrapper .availability-input-wrapper {\r\ndisplay: flex;\r\nalign-items: center;\r\ngap: 20px;\r\n}\r\n\r\n.availability-offcanvas-wrapper .availability-main-wrap {\r\ngap: 24px;\r\n}\r\n\r\n\r\n.drawer-main-header-wrap {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  margin-bottom: 20px;\r\n  padding-left: 20px;\r\n  padding-right: 20px;\r\n}\r\n\r\n\r\n.drawer-main-header-wrap h4{\r\n  font-size: 24px;\r\n  color: #1A1919;\r\n  font-weight: 600;\r\n  margin: 0px;\r\n}\r\n\r\n\r\n.drawer-main-header-wrap img{\r\n  cursor: pointer;\r\n}\r\n\r\n\r\n.history-list-drawer-table  thead {\r\n  background-color: #00A19B08; /* Background color for thead */\r\n}\r\n\r\n.history-list-drawer-table .table.table-hover thead th  {\r\n  padding: 10px; /* Optional padding */\r\n  background-color: #00A19B08; /* Background color for each th */\r\n}\r\n\r\n\r\n.history-list-drawer-table .table-hover>tbody>tr:hover>* {\r\n  --bs-table-color-state: unset !important;\r\n  --bs-table-bg-state: unset !important;\r\n}\r\n\r\n.history-list-drawer-table tbody, td, tfoot, th, thead, tr {\r\n  border-color: inherit;\r\n  border-style: solid;\r\n  border-width: 0;\r\n  border: none;\r\n}\r\n\r\n.history-list-drawer-table thead th:first-child {\r\n  border-top-left-radius: 15px; \r\n  border-bottom-left-radius: 15px;\r\n}\r\n\r\n.history-list-drawer-table thead th:last-child {\r\n  border-top-right-radius: 15px; \r\n  border-bottom-right-radius: 15px;\r\n}\r\n\r\n\r\n.history-list-drawer-table .table.table-hover thead th {\r\n  color: #383838;\r\n  font-size: 20px;\r\n}\r\n\r\n.history-list-drawer-table .table tbody tr td {\r\n  font-size: 18px;\r\n  cursor: pointer;\r\n}\r\n\r\n.history-list-drawer-table .table.table-hover thead th {\r\n  color: #383838;\r\n  font-size: 18px;\r\n  font-weight: 600;\r\n  padding-left: 20px;\r\n}\r\n\r\n.history-list-drawer-table .table tbody tr td {\r\n  color: #717171;\r\n  font-size: 18px;\r\n  white-space: nowrap;\r\n  padding-left: 18px;\r\n  vertical-align: middle;\r\n}\r\n\r\n\r\n\r\n/* .history-list-drawer-table .table-responsive {\r\n  -webkit-overflow-scrolling: touch;\r\n  height: 85vh;\r\n  overflow-x: auto;\r\n  overflow-y: auto;\r\n} */\r\n\r\n.history-item-images-wrapper {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 22px;\r\n}\r\n\r\n.history-item-images-holder {\r\n  display: flex;\r\n}\r\n\r\n.history-item-image-box {\r\n  width: 38px;\r\n  background: #f3f3f3;\r\n  border-radius: 50%;\r\n  margin-left: -14px;\r\n  padding: 6px;\r\n}\r\n\r\n.history-item-images-holder img {\r\n  width: 100%;\r\n}\r\n\r\n.history-item-images-wrapper img.main-image  {\r\n  width: 50px;\r\n}\r\n\r\n\r\n.items-hold-wrap {\r\ndisplay: flex;\r\nalign-items: center;\r\ngap: 0px;\r\n}\r\n\r\n.items-hold-wrap p {\r\nwidth: 200px;\r\nfont-size: 18px;\r\ncolor: #919191;\r\nfont-weight: 400;\r\nmargin: 0px;\r\ntext-overflow: ellipsis;\r\nwhite-space: nowrap;\r\noverflow: hidden;\r\n}\r\n\r\n.items-hold-wrap span{\r\nfont-size: 18px;\r\ncolor: #00A19B;\r\nfont-weight: 400;\r\nmargin: 0px;\r\n\r\n}\r\n\r\n/************** Chat Masseges Drawer ****/\r\n.replay-chat-box-wrapper {\r\nposition: relative;\r\nmargin-top: 20px;\r\nwidth: 100%;\r\nheight: calc(100vh - 170px);\r\n}\r\n\r\n\r\n/******** Chat Bot Msg *****/\r\n.msger-chat {\r\n  flex: 1;\r\n  overflow-y: auto;\r\n  padding: 20px 20px;\r\n  height: calc(100vh - 260px);\r\n}\r\n\r\n.msger-chat::-webkit-scrollbar {\r\n  width: 5px;\r\n  border-radius: 10px;\r\n  \r\n}\r\n\r\n.msger-chat::-webkit-scrollbar-track {\r\n  background: #ddd;\r\n}\r\n\r\n.msger-chat::-webkit-scrollbar-thumb {\r\n  background: #00A19B;\r\n}\r\n\r\n.msg {\r\n  display: flex;\r\n  align-items: flex-end;\r\n}\r\n\r\n.msg:last-of-type {\r\n  margin: 0;\r\n}\r\n\r\n.msg-bubble {\r\n  max-width: 450px;\r\n  padding: 15px;\r\n  border-radius: 25px;\r\n  background: #BAE9E9;\r\n}\r\n\r\n.msg-info {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  margin-bottom: 8px;\r\n}\r\n\r\n.msg-info-name {\r\n  font-size: 14px;\r\n  color: #313131;\r\n  font-weight: 500;\r\n  margin-left: 20px;\r\n}\r\n\r\n.msg-info-time {\r\n  font-size: 0.85em;\r\n}\r\n\r\n\r\n\r\n.right-msg {\r\n  flex-direction: row-reverse;\r\n}\r\n\r\n.right-msg .msg-bubble {\r\n  background: #00A19B;\r\n  color: #fff;\r\n  border-radius: 25px;\r\n}\r\n\r\n.replay-chat-box-wrap .msg.left-msg .msg-text {\r\n  font-size: 16px;\r\n  color: #1A1919;\r\n  font-weight: 600;\r\n  margin: 0px;\r\n}\r\n\r\n.replay-chat-box-wrap .msg .msg-text {\r\nfont-size: 16px;\r\ncolor: #FFFFFF;\r\nfont-weight: 600;\r\nmargin: 0px;\r\n}\r\n\r\n.chat-right-message-wrap .msg-info-time p {\r\n  font-size: 14px;\r\n  color: #B5B5B5;\r\n  font-weight: 400;\r\n  margin: 0px;\r\n  text-align: right;\r\n  padding-right: 10px;\r\n}\r\n\r\n.chat-left-message-wrap .msg-info-time p {\r\n  font-size: 14px;\r\n  color: #B5B5B5;\r\n  font-weight: 400;\r\n  margin: 0px;\r\n  padding-right: 10px;\r\n}\r\n\r\n.chat-right-message-wrap{\r\n  margin-bottom: 16px;\r\n}\r\n\r\n\r\n.right-info-time {\r\n  text-align: right;\r\n}\r\n\r\n.left-info-time {\r\n  text-align: left;\r\n}\r\n\r\n.right-info-time p, .left-info-time p {\r\nfont-size: 14px;\r\ncolor: #B5B5B5;\r\nfont-weight: 400;\r\npadding-top: 4px;\r\nmargin-left: 20px;\r\nmargin-right: 20px;\r\n}\r\n\r\n\r\n\r\n.chat-send-message-wrapper{\r\nposition: absolute;\r\nwidth: 100%;\r\nbottom: 0px;\r\n}\r\n\r\n\r\n.chat-send-message-wrap{\r\nposition: relative;\r\n}\r\n\r\n.chat-send-message-wrap input {\r\nwidth: 100%;\r\nheight: 82px;\r\nborder: 1px solid #DFDFDF;\r\nborder-radius: 42px;\r\noutline: none;\r\npadding: 30px;\r\n}\r\n\r\n.chat-send-button img {\r\nwidth: 65px;\r\nposition: absolute;\r\ntop: 10px;\r\nright: 10px;\r\ncursor: pointer;\r\n}\r\n\r\n\r\n.chat-date-divider {\r\nwidth: 80%;\r\nborder: 1px solid #E9E9E9;\r\nheight: 0px;\r\ndisplay: flex;\r\nalign-items: center;\r\njustify-content: center;\r\nmargin: 0 auto;\r\nmargin-top: 26px;\r\nmargin-bottom: 34px;\r\n}\r\n\r\n.chat-date-divider span {\r\ndisplay: block;\r\nbackground: #fff;\r\npadding: 0px 20px;\r\ncolor: #B5B5B5;\r\nfont-size: 14px;\r\nfont-weight: 400;\r\n}\r\n\r\n\r\n.notification-drawer-header h3 {\r\nfont-size: 24px;\r\ncolor: #1A1919;\r\nfont-weight: 600;\r\nmargin: 0px;\r\n}\r\n\r\n.notification-drawer-header {\r\ndisplay: flex;\r\nalign-items: center;\r\njustify-content: space-between;\r\nposition: sticky;\r\ntop: 0;\r\nbackground: #fff;\r\npadding-top: 20px;\r\n}\r\n\r\n.notification-drawer-header img{\r\nwidth: 38px;\r\ncursor: pointer;\r\n}\r\n\r\n\r\n.noting-found-main-wrap img {\r\nwidth: 112px;\r\nmargin-bottom: 10px;\r\n}\r\n\r\n.noting-found-main-wrap p {\r\nfont-size: 24px;\r\ncolor: #B2B2B2;\r\nmargin: 0px;\r\nfont-weight: 400;\r\n}\r\n\r\n\r\n.noting-found-main-wrap {\r\ndisplay: flex;\r\nflex-direction: column;\r\njustify-content: center;\r\nalign-items: center;\r\nheight: calc(100vh - 200px);\r\n}\r\n\r\n.nothing-found-cart-wrap{\r\nheight: calc(100vh - 210px);\r\n}\r\n\r\n.cleaner-partner.right {\r\ndisplay: none;\r\n}\r\n\r\n.cleaner-partner.left{\r\nfont-size: 18px;\r\ncolor: #1A1919;\r\nfont-weight: 400;\r\nmargin: 0px;\r\nmargin-bottom: 4px;\r\n}\r\n\r\n\r\n.empty-conversation-wrap {\r\ndisplay: flex;\r\nalign-items: center;\r\njustify-content: center;\r\nflex-direction: column;\r\nheight: calc(100vh - 260px);\r\n}\r\n\r\n.empty-conversation-wrap h3 {\r\nfont-size: 25px;\r\ncolor: #1A1919;\r\nfont-weight: bold;\r\nmargin: 0px;\r\n}\r\n\r\n.empty-conversation-wrap p {\r\nfont-size: 22px;\r\ncolor: #1A1919;\r\nfont-weight: 400;\r\ntext-align: center;\r\nwidth: 60%;\r\npadding-top: 10px;\r\n}\r\n\r\n.empty-conversation-wrap img {\r\nwidth: 150px;\r\n}\r\n\r\n\r\n/**************** Service Drawer css ********/\r\n.service-drawer-header {\r\ndisplay: flex;\r\nalign-items: center;\r\njustify-content: space-between;\r\nmargin-bottom: 54px;\r\n}\r\n\r\n.service-drawer-header h3 {\r\nfont-size: 24px;\r\ncolor: #1A1919;\r\nfont-weight: 600;\r\nmargin: 0px;\r\n}\r\n\r\n.service-drawer-header img {\r\nwidth: 36px;\r\ncursor: pointer;\r\n}\r\n\r\n.service-drawer-main-wrapper button.accordion-button img {\r\nwidth: 74px;\r\nmargin-right: 10px;\r\n}\r\n\r\n.service-drawer-main-wrapper button.accordion-button p {\r\nfont-size: 18px;\r\ncolor: #1A1919;\r\nmargin: 0px;\r\nfont-weight: 400;\r\nmargin-top: 10px;\r\n}\r\n\r\n.service-drawer-main-wrapper .commerical-services-wrap h4 {\r\nfont-size: 18px;\r\n}\r\n\r\n.service-drawer-main-wrapper .checkbox-container {\r\n  font-size: 16px;\r\n  padding-left: 50px;\r\n  margin-bottom: 16px;\r\n}\r\n\r\n.service-drawer-main-wrapper .checkbox-container .checkmark {\r\n  height: 24px;\r\n  width: 24px;\r\n}\r\n\r\n.service-drawer-main-wrapper .commerical-services-wrap {\r\npadding: 14px 20px;\r\n}\r\n\r\n.profile-service-drawer-wrapper .commerical-services-wrap {\r\npadding: 16px 46px;\r\n}\r\n\r\n.service-drawer-main-wrapper .specail-service-commerical-wrapper {\r\nwidth: 95%;\r\n/* margin: 0 auto; */\r\n}\r\n\r\n.bussiness-location-btn.service-edit-button {\r\nwidth: 95%;\r\nmargin-top: 160px;\r\n}\r\n\r\n.service-drawer-head-left p{\r\nfont-size: 14px;\r\ncolor: #1A1919;\r\nfont-weight: 400;\r\nmargin: 0px;\r\n}\r\n\r\n.service-drawer-head-left p span{\r\ncolor: #9ea1f3;\r\n}\r\n\r\n.profile-service-drawer-header{\r\nalign-items: baseline;\r\n}\r\n\r\n/********************* Bank Detail Drawer css ******/\r\n.bank-detail-drawer-form {\r\nmargin-top: 100px;\r\n}\r\n\r\n.bank-detail-drawer-btn{\r\nmargin-top: 100px;\r\n}\r\n\r\n.bank-detail-drawer-form  .field {\r\nmargin-bottom: 30px;\r\n}\r\n\r\n.bank-detail-drawer-form .login-option input {\r\nwidth: 100%;\r\nheight: 80px;\r\nfont-size: 18px;\r\nfont-weight: 500;\r\n}\r\n\r\n.bank-detail-head-contant p {\r\nfont-size: 16px;\r\ncolor: #8A8A8A;\r\nfont-weight: 400;\r\nmargin: 0px;\r\n}\r\n\r\n.bank-cheque-image-wrap {\r\nmargin-top: 130px;\r\n}\r\n\r\n.cheque-edit-state{\r\nmargin-top: 85px;\r\n}\r\n\r\n.bank-cheque-image-wrap img {\r\nwidth: 100%;\r\n}\r\n\r\n.bank-detail-drawer-btn{\r\nwidth: 530px;\r\nbottom: 60px;\r\n}\r\n\r\n\r\n.bank-check-upload-wrap {\r\nwidth: 80%;\r\nmargin: 0 auto;\r\nmargin-top: 50px;\r\n}\r\n\r\n.cheque-status-wrap {\r\ndisplay: flex;\r\nalign-items: center;\r\njustify-content: space-between;\r\nbackground: #F3F3F3;\r\nheight: 87px;\r\nborder-radius: 17px;\r\npadding: 0px 40px;\r\nposition: fixed;\r\nbottom: 140px;\r\nwidth: 530px;\r\n}\r\n\r\n\r\n.cheque-status-left h3 {\r\nfont-size: 14px;\r\ncolor: #1A1919;\r\nfont-weight: 600;\r\nmargin: 0px;\r\n}\r\n\r\n.cheque-status-right{\r\ndisplay: flex;\r\ngap: 4px;\r\nalign-items: center;\r\n}\r\n\r\n.cheque-status-right img{\r\nwidth: 30px;\r\n}\r\n\r\n.cheque-status-right p {\r\nfont-size: 14px;\r\ncolor: #00A19B;\r\nfont-weight: 500;\r\nmargin: 0px;\r\n}\r\n\r\n.bank-cheque-edit-wrap{\r\ndisplay: flex;\r\nalign-items: center;\r\njustify-content: flex-end;\r\ngap: 16px;\r\nmargin-bottom: 20px;\r\n}\r\n\r\n.bank-cheque-edit-wrap h3{\r\nfont-size: 22px;\r\ncolor: #1A1919;\r\nfont-weight: 600;\r\nmargin: 0px;\r\n}\r\n\r\n.bank-cheque-edit-wrap img{\r\nwidth: 24px;\r\ncursor: pointer;\r\n}\r\n\r\np.edit-cheque-info-text {\r\nfont-size: 14px;\r\ncolor: #707070;\r\nmargin-top: 8px;\r\nmargin: 0px;\r\nmargin-top: 8px;\r\n}\r\n\r\n\r\n\r\n/**************** Availability Drawer css ********/\r\n.availability-drawer-main-wrapper .availability-day-wrap {\r\nwidth: 74px;\r\nheight: 74px;\r\n}\r\n\r\n.availability-drawer-main-wrapper .availability-day-wrap h3 {\r\nfont-size: 24px;\r\n}\r\n\r\n.availability-drawer-main-wrapper .availability-input-left-wrap input {\r\nwidth: 180px;\r\nheight: 64px;\r\nborder-radius: 18px;\r\n}\r\n\r\n.availability-drawer-main-wrapper .availability-input-wrapper p {\r\nfont-size: 16px;\r\ncolor: #1A1919;\r\nfont-weight: 500;\r\n}\r\n\r\n.availability-drawer-main-wrapper .plus-icon-wrap img, .minus-icon-wrap img {\r\nwidth: 65px;\r\ncursor: pointer;\r\n}\r\n\r\n.availability-drawer-main-wrapper .availability-input-left-wrap input {\r\nfont-size: 18px;\r\nfont-weight: 600;\r\n}\r\n\r\n.availability-drawer-main-wrapper .availability-input-repeat {\r\ngap: 32px;\r\n}\r\n\r\n.availability-drawer-main-wrapper  .availability-main-wrap {\r\nmargin-bottom: 32px;\r\n}\r\n\r\n\r\n.availability-drawer-main-wrapper .signup-availibty-save-btn{\r\nposition: sticky;\r\nbottom: 0px;\r\nbackground: #fff;\r\npadding-right: 20px;\r\n}\r\n\r\n.availability-drawer-main-wrapper .signup-availibty-save-btn button {\r\nmargin-top: 30px;\r\nheight: 64px;\r\n}\r\n\r\n.availability-main-wrapper {\r\noverflow-y: auto !important;\r\nheight: calc(100vh - 320px);\r\npadding-right: 20px;\r\n}\r\n\r\n\r\n/*********** Menu Drawer Css *******/\r\n\r\n.menu-drawer-header {\r\ndisplay: flex;\r\nalign-items: center;\r\njustify-content: space-between;\r\nheight: 70px;\r\npadding: 0px 20px;\r\nbackground: #00A19B;\r\nwidth: 100%;\r\n}\r\n\r\n.menu-drawer-header .nav-review-stars svg {\r\nwidth: 18px;\r\n}\r\n\r\n.menu-drawer-left {\r\ndisplay: flex;\r\nalign-items: center;\r\ngap: 0px;\r\n}\r\n\r\n.menu-header-profile img {\r\nwidth: 67px;\r\n}\r\n\r\n.menu-contractor-detail h3 {\r\nfont-size: 18px;\r\ncolor: #FFFFFF;\r\nfont-weight: 600;\r\nmargin: 0px;\r\n}\r\n\r\n.menu-contractor-detail p {\r\n  font-size: 14px;\r\n  color: #FFFFFF;\r\n  font-weight: 400;\r\n  margin: 0px;\r\n  width: 240px;\r\n  overflow: hidden;\r\n  white-space: nowrap;\r\n  text-overflow: ellipsis;\r\n}\r\n\r\n.menu-offcanvas-wrapper .offcanvas-body{\r\npadding: 0px;\r\n}\r\n\r\n.menu-drawer-header .menu-drawer-right img {\r\n  width: 30px;\r\n  cursor: pointer;\r\n}\r\n\r\n/* .menu-drawer-main-wrap{\r\npadding: 20px 0px;\r\n} */\r\n\r\n.menu-drawer-tab-wrap {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 22px;\r\n  cursor: pointer;\r\n}\r\n\r\n.menu-drawer-tab-wrap img {\r\n  width: 35px;\r\n  display: none;\r\n}\r\n\r\n.menu-drawer-tab-repeat {\r\nborder-bottom: 2px solid #F3F3F3;\r\npadding: 26px 24px\r\n}\r\n\r\n.menu-drawer-tab-wrap p {\r\nfont-size: 16px;\r\ncolor: #1A1919;\r\nfont-weight: 600;\r\nmargin: 0px;\r\n}\r\n\r\n.menu-drawer-tab-repeat:hover .menu-drawer-tab-wrap p {\r\ncolor: #00A19B;\r\n}\r\n\r\n.status-drawer-close-icon {\r\nposition: absolute;\r\nright: 20px;\r\ntop: 50px;\r\n}\r\n\r\nimg.remove-delete-icon{\r\ndisplay: none;\r\n}\r\n\r\n/******* Resposive css ****/\r\n@media (max-width: 767px) {\r\n.history-offcanvas-wrapper.offcanvas.offcanvas-end.show {\r\n  width: 100%;\r\n  box-shadow: -5px 0px 14px #0000000D;\r\n  border-radius: 0px;\r\n  padding: 30px 0px 30px 0px;\r\n  z-index: 99999;\r\n}\r\n\r\n.empty-conversation-wrap p {\r\n  width: 100%;\r\n}\r\n\r\n.chat-offcanvas-wrapper.offcanvas.offcanvas-end.show {\r\n  border-radius: 0px;\r\n  padding: 20px;\r\n}\r\n\r\n.chat-date-divider {\r\n  width: 100%;\r\n}\r\n\r\n.replay-chat-box-wrapper {\r\n  margin-top: 10px;\r\n}\r\n\r\n.msger-chat {\r\n  padding: 10px 0px;\r\n}\r\n\r\n.empty-conversation-wrap h3 {\r\n  font-size: 22px;\r\n}\r\n\r\n.empty-conversation-wrap p {\r\n  font-size: 20px;\r\n}\r\n\r\n.empty-conversation-wrap img {\r\n  width: 120px;\r\n}\r\n\r\n.notification-drawer-header img {\r\n  width: 34px;\r\n}\r\n\r\n.availability-offcanvas-wrapper.offcanvas.offcanvas-end.show {\r\n  width: 100%;\r\n  box-shadow: -5px 0px 14px #0000000D;\r\n  border-radius: 0px;\r\n  padding: 58px 0px 10px 10px;\r\n}\r\n\r\n.service-drawer-header h3 {\r\n  font-size: 22px;\r\n}\r\n\r\n.bank-detail-head-contant p {\r\n  font-size: 14px;\r\n}\r\n\r\n.availability-drawer-main-wrapper .availability-day-wrap {\r\n  width: 38px;\r\n  height: 38px;\r\n}\r\n\r\n.availability-drawer-main-wrapper .availability-day-wrap h3 {\r\n  font-size: 12px;\r\n}\r\n\r\n.availability-drawer-main-wrapper .availability-input-left-wrap input {\r\n  width: 106px;\r\n  height: 40px;\r\n  border-radius: 9px;\r\n  font-size: 12px;\r\n}\r\n\r\n.availability-drawer-main-wrapper .availability-input-wrapper p {\r\n  font-size: 12px;\r\n}\r\n\r\n.availability-offcanvas-wrapper .availability-input-wrapper {\r\n  gap: 10px;\r\n}\r\n\r\n.availability-drawer-main-wrapper .plus-icon-wrap img, .minus-icon-wrap img {\r\n  width: 37px;\r\n}\r\n\r\n.availability-offcanvas-wrapper .availability-main-wrap {\r\n  gap: 18px;\r\n}\r\n\r\n\r\n.availability-offcanvas-wrapper .offcanvas-body {\r\npadding-right: 0px;\r\n}\r\n\r\n.availability-main-wrapper {\r\noverflow-y: auto !important;\r\nheight: calc(100vh - 320px);\r\npadding-right: 0px;\r\n}\r\n\r\n.availability-drawer-main-wrapper .signup-availibty-save-btn button {\r\nmargin-top: 10px;\r\nheight: 49px;\r\n}\r\n\r\n.bankdetail-offcanvas-wrapper.offcanvas.offcanvas-end.show {\r\nwidth: 100%;\r\nborder-radius: 0px;\r\npadding: 58px 12px 20px 14px;\r\n}\r\n\r\n.drawer-close-icon-wrap img {\r\nwidth: 34px;\r\n}\r\n\r\n.bank-cheque-image-wrap {\r\nmargin-top: 100px;\r\n}\r\n\r\n.bank-detail-drawer-btn {\r\nwidth: 100%;\r\nbottom: 20px;\r\n}\r\n\r\n.bank-detail-drawer-btn button{\r\nheight: 49px;\r\nfont-size: 14px;\r\n}\r\n\r\n.cheque-status-wrap {\r\ndisplay: flex;\r\nalign-items: center;\r\njustify-content: space-between;\r\nbackground: #F3F3F3;\r\nheight: 48px;\r\nborder-radius: 9px;\r\npadding: 0px 20px;\r\nposition: fixed;\r\nbottom: 110px;\r\nwidth: 86%;\r\n}\r\n\r\n.cheque-status-right p {\r\nfont-size: 12px;\r\n}\r\n\r\n.bank-cheque-edit-wrap h3 {\r\nfont-size: 14px;\r\n}\r\n\r\n.bank-cheque-edit-wrap img {\r\nwidth: 15px;\r\n}\r\n\r\n.bank-cheque-edit-wrap {\r\ngap: 10px;\r\nmargin-bottom: 10px;\r\n}\r\n\r\n.cheque-edit-state {\r\nmargin-top: 80px;\r\n}\r\n\r\n\r\np.edit-cheque-info-text {\r\nfont-size: 12px;\r\n}\r\n\r\n.bank-check-upload-wrap {\r\nwidth: 86%;\r\n}\r\n\r\n.bank-check-upload-wrap .certificate-upload-box {\r\nheight: 48px;\r\n}\r\n\r\n.drawer-close-icon-wrap img {\r\nwidth: 34px;\r\n}\r\n\r\n.service-drawer-main-wrapper .commerical-services-wrap h4 {\r\nfont-size: 14px;\r\n}\r\n\r\n.profile-commerical-services-select-wrap p, .profile-commerical-speciality-select-wrap p {\r\nfont-size: 12px;\r\n}\r\n\r\n.profile-service-drawer-wrapper .commerical-services-wrap {\r\npadding: 16px 20px;\r\n}\r\n\r\n.profile-commerical-services-select-wrap {\r\ndisplay: grid;\r\ngrid-template-columns: repeat(3, 1fr);\r\n}\r\n\r\n.profile-commerical-speciality-select-wrap {\r\ndisplay: grid;\r\ngrid-template-columns: repeat(2, 1fr);\r\ngap: 6px;\r\n}\r\n\r\n.profile-commerical-speciality-select-wrap p{\r\nmargin-bottom: 10px;\r\n}\r\n\r\n.service-drawer-main-wrapper button.accordion-button img {\r\nwidth: 56px;\r\n}\r\n\r\n.service-drawer-main-wrapper button.accordion-button p {\r\nfont-size: 16px;\r\n}\r\n\r\n.accordion-item {\r\nmargin-top: 32px;\r\n}\r\n\r\n.drawer-close-icon-wrap {\r\nposition: absolute;\r\nright: 30px;\r\ntop: 30px;\r\n}\r\n\r\n.service-drawer-head-left p {\r\nwidth: 90%;\r\n}\r\n\r\n.service-drawer-header {\r\nmargin-bottom: 40px;\r\n}\r\n\r\n.cheque-status-right img {\r\nwidth: 20px;\r\n}\r\n\r\n\r\n}\r\n\r\n\r\n@media (max-width: 360px) {\r\n.availability-drawer-main-wrapper .availability-input-left-wrap input {\r\n  width: 100px;\r\n}\r\n\r\n.availability-offcanvas-wrapper .availability-main-wrap {\r\n  gap: 10px;\r\n}\r\n\r\n.bank-detail-head-contant p {\r\n  font-size: 12px;\r\n}\r\n\r\n.service-drawer-header h3 {\r\n  font-size: 20px;\r\n}\r\n\r\n.menu-contractor-detail p {\r\n  width: 200px;\r\n}\r\n\r\n}\r\n\r\n@media (min-width: 768px) and (max-width: 1024px) {\r\n.availability-offcanvas-wrapper.offcanvas.offcanvas-end.show {\r\n  width: 532px;\r\n  box-shadow: -5px 0px 14px #0000000D;\r\n  border-radius: 34px 0px 0px 34px;\r\n  padding: 35px 0px 10px 32px;\r\n  z-index: 99999;\r\n  background: #fff;\r\n}\r\n\r\n.service-drawer-header h3 {\r\nfont-size: 18px;\r\npadding-bottom: 6px;\r\n}\r\n\r\n.bank-detail-head-contant p {\r\nfont-size: 14px;\r\n}\r\n\r\n.availability-drawer-main-wrapper .availability-day-wrap {\r\nwidth: 47px;\r\nheight: 47px;\r\n}\r\n\r\n.availability-drawer-main-wrapper .availability-input-left-wrap input {\r\nwidth: 135px;\r\nheight: 48px;\r\nborder-radius: 9px;\r\nfont-size: 14px;\r\n}\r\n\r\n.availability-drawer-main-wrapper .plus-icon-wrap img, .minus-icon-wrap img {\r\nwidth: 47px;\r\n}\r\n\r\n.availability-drawer-main-wrapper .availability-input-wrapper p {\r\nfont-size: 14px;\r\n}\r\n\r\n.availability-drawer-main-wrapper .availability-main-wrap {\r\nmargin-bottom: 22px;\r\ngap: 18px;\r\n}\r\n\r\n.availability-drawer-main-wrapper .availability-day-wrap h3 {\r\nfont-size: 14px;\r\n}\r\n\r\n.availability-drawer-main-wrapper .signup-availibty-save-btn button {\r\nmargin-top: 30px;\r\nheight: 49px;\r\n}\r\n\r\n.service-drawer-header {\r\nmargin-bottom: 34px;\r\n}\r\n\r\n.availability-main-wrapper {\r\nheight: calc(100vh - 260px);\r\n}\r\n\r\n\r\n.bankdetail-offcanvas-wrapper.offcanvas.offcanvas-end.show {\r\nwidth: 520px;\r\npadding: 35px 26px 20px 26px;\r\n}\r\n\r\n.bank-cheque-image-wrap {\r\nmargin-top: 60px;\r\n}\r\n\r\n.bank-detail-drawer-btn {\r\nwidth: 430px;\r\nbottom: 50px;\r\nmargin-top: 80px;\r\n}\r\n\r\n\r\n.bank-cheque-edit-wrap h3 {\r\nfont-size: 14px;\r\n}\r\n\r\n.bank-cheque-edit-wrap img {\r\nwidth: 16px;\r\n}\r\n\r\n.bank-cheque-edit-wrap {\r\ngap: 10px;\r\nmargin-bottom: 12px;\r\n}\r\n\r\n.cheque-status-wrap {\r\nwidth: 430px;\r\nheight: 48px;\r\nborder-radius: 9px;\r\npadding: 0px 40px;\r\nbottom: 120px;\r\n}\r\n\r\n.cheque-edit-state {\r\nmargin-top: 20px;\r\n}\r\n\r\n.cheque-status-left h3 {\r\nfont-size: 12px;\r\n}\r\n\r\n.cheque-status-right p {\r\nfont-size: 12px;\r\n}\r\n\r\n\r\n.service-drawer-main-wrapper button.accordion-button img {\r\nwidth: 52px;\r\n}\r\n\r\n.service-drawer-main-wrapper button.accordion-button p {\r\nfont-size: 16px;\r\n}\r\n\r\n.service-drawer-main-wrapper .accordion-item .accordion-header .accordion-button {\r\npadding: 10px 20px;\r\nheight: 76px;\r\n}\r\n\r\n.service-drawer-main-wrapper .commerical-services-wrap h4 {\r\nfont-size: 14px;\r\n}\r\n\r\n.profile-commerical-services-select-wrap p, .profile-commerical-speciality-select-wrap p {\r\nfont-size: 12px;\r\n}\r\n\r\n.cheque-status-right img {\r\nwidth: 20px;\r\n}\r\n\r\n}\r\n\r\n\r\n@media (min-width: 1025px) and (max-width: 1599px) {\r\n.availability-offcanvas-wrapper.offcanvas.offcanvas-end.show {\r\n  width: 580px;\r\n  box-shadow: -5px 0px 14px #0000000D;\r\n  border-radius: 34px 0px 0px 34px;\r\n  padding: 35px 0px 10px 32px;\r\n  z-index: 99999;\r\n  background: #fff;\r\n}\r\n\r\n.service-drawer-main-wrapper .checkbox-container {\r\n  font-size: 14px;\r\n  padding-left: 36px;\r\n  margin-bottom: 16px;\r\n}\r\n\r\n.service-drawer-header h3 {\r\nfont-size: 18px;\r\npadding-bottom: 6px;\r\n}\r\n\r\n.bank-detail-head-contant p {\r\nfont-size: 14px;\r\n}\r\n\r\n.availability-drawer-main-wrapper .availability-day-wrap {\r\nwidth: 47px;\r\nheight: 47px;\r\n}\r\n\r\n.availability-drawer-main-wrapper .availability-input-left-wrap input {\r\nwidth: 150px;\r\nheight: 48px;\r\nborder-radius: 9px;\r\nfont-size: 14px;\r\n}\r\n\r\n.availability-drawer-main-wrapper .plus-icon-wrap img, .minus-icon-wrap img {\r\nwidth: 47px;\r\n}\r\n\r\n.availability-drawer-main-wrapper .availability-input-wrapper p {\r\nfont-size: 14px;\r\n}\r\n\r\n.availability-drawer-main-wrapper .availability-main-wrap {\r\nmargin-bottom: 22px;\r\ngap: 18px;\r\n}\r\n\r\n.availability-drawer-main-wrapper .availability-day-wrap h3 {\r\nfont-size: 14px;\r\n}\r\n\r\n.availability-drawer-main-wrapper .signup-availibty-save-btn button {\r\nmargin-top: 30px;\r\nheight: 49px;\r\n}\r\n\r\n.service-drawer-header {\r\nmargin-bottom: 34px;\r\n}\r\n\r\n.availability-main-wrapper {\r\nheight: calc(100vh - 260px);\r\n}\r\n\r\n\r\n.bankdetail-offcanvas-wrapper.offcanvas.offcanvas-end.show {\r\nwidth: 520px;\r\npadding: 35px 26px 20px 26px;\r\n}\r\n\r\n.bank-cheque-image-wrap {\r\nmargin-top: 60px;\r\n}\r\n\r\n.bank-detail-drawer-btn {\r\nwidth: 430px;\r\nbottom: 40px;\r\nmargin-top: 80px;\r\n}\r\n\r\n.bank-cheque-edit-wrap h3 {\r\nfont-size: 14px;\r\n}\r\n\r\n.bank-cheque-edit-wrap img {\r\nwidth: 16px;\r\n}\r\n\r\n.bank-cheque-edit-wrap {\r\ngap: 10px;\r\nmargin-bottom: 12px;\r\n}\r\n\r\n.cheque-status-wrap {\r\nwidth: 430px;\r\nheight: 48px;\r\nborder-radius: 9px;\r\npadding: 0px 40px;\r\nbottom: 100px;\r\n}\r\n\r\n.cheque-edit-state {\r\nmargin-top: 20px;\r\n}\r\n\r\n.cheque-status-left h3 {\r\nfont-size: 12px;\r\n}\r\n\r\n.cheque-status-right p {\r\nfont-size: 12px;\r\n}\r\n\r\n.service-drawer-head-left p {\r\nfont-size: 12px;\r\n}\r\n\r\n.signup-special-services-wrap {\r\nmargin-top: 20px;\r\n}\r\n\r\n.service-drawer-main-wrapper button.accordion-button img {\r\nwidth: 52px;\r\n}\r\n\r\n.service-drawer-main-wrapper button.accordion-button p {\r\nfont-size: 16px;\r\n}\r\n\r\n.service-drawer-main-wrapper .accordion-item .accordion-header .accordion-button {\r\npadding: 10px 20px;\r\nheight: 76px;\r\n}\r\n\r\n.service-drawer-main-wrapper .commerical-services-wrap h4 {\r\nfont-size: 14px;\r\n}\r\n\r\n.profile-commerical-services-select-wrap p, .profile-commerical-speciality-select-wrap p {\r\nfont-size: 12px;\r\n}\r\n\r\np.edit-cheque-info-text {\r\nfont-size: 12px;\r\n}\r\n\r\n.cheque-status-right img {\r\nwidth: 20px;\r\n}\r\n}\r\n\r\n\r\n\r\n\r\n@media (min-width: 1025px) and (max-width: 1199px) {\r\n\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
